(function () {
'use strict';

var documentInit;

(function ($) {

	documentInit = function () {
		new Document();
	};

	class Document {
		constructor() {
			this.init();
			this.bind();
		}

		init() {
			this.$body = $(document.body);

			document.headerHeightScrolled = 100;

			// Initialize scroll tracking variables
			this.lastScrollTop = 0;
			this.scrollDirection = 'none';
			this.$body.css('--current-scrolltop', `${window.scrollY}px`);

			this.scrollThreshold = 5; // Hysteresis threshold in pixels
		}

		bind() {
			$(window).scroll((e) => { this.scroll(); });
			$(window).on('resize', this.setVw);
		}

		scroll() {
			var scroll = window.scrollY;

			// Add scroll position as CSS variables
			this.$body.css('--current-scrolltop', `${scroll}px`);

			// Add clamped percentage (max 100%)
			const headerHeight = document.headerHeightScrolled || 100;
			const scrollPercentage = Math.min(100, (scroll / headerHeight) * 100);
			this.$body.css('--scroll-percentage', `${scrollPercentage}%`);

			// Detect scroll direction with hysteresis
			if (Math.abs(scroll - this.lastScrollTop) > this.scrollThreshold) {
				if (scroll > this.lastScrollTop) {
					// Scrolling down - only add class if past header height
					if (this.scrollDirection !== 'down' && scroll >= document.headerHeightScrolled) {
						this.$body.removeClass('is-scrolling-up').addClass('is-scrolling-down');
						this.scrollDirection = 'down';
					} else if (this.scrollDirection === 'up') {
						// If we were scrolling up but now going down, just remove up class
						this.$body.removeClass('is-scrolling-up');
						this.scrollDirection = 'none';
					}
				} else {
					// Scrolling up - always add class regardless of position
					if (this.scrollDirection !== 'up') {
						this.$body.removeClass('is-scrolling-down').addClass('is-scrolling-up');
						this.scrollDirection = 'up';
					}
				}
				this.lastScrollTop = scroll;
			}

			// Handle scrolled state
			if (scroll > 0 && !this.$body.hasClass('is-scrolled')) {
				this.$body.addClass('is-scrolled');
				return;
			}

			if (scroll == 0 && this.$body.hasClass('is-scrolled')) {
				this.$body.removeClass('is-scrolled');
				this.$body.removeClass('is-scrolling-up is-scrolling-down');
				this.scrollDirection = 'none';
				return;
			}
		}

		setVw() {
			let vw = document.documentElement.clientWidth / 100;
			document.documentElement.style.setProperty('--vw', `${vw}px`);
		}
	}

})(jQuery);

var documentInit$1 = documentInit;

var mobileNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-mobile-menu]',
		trigger: '[data-mobile-menu-trigger]',
	};

	mobileNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new MobileNav(el);
		});
	};

	class MobileNav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();

		}
		init() {
			this.$trigger = $(selectors.trigger, this.$container);
			this.$dropdownTrigger = $('.c-nav__item-arrow, a[href="#"]', this.$container);
			this.$links = $('a:not([href="#"])', this.$container).not(this.$trigger);

			this.$dropdownTrigger.on('click', this.toggleDropdown.bind(this));

		}

		bind() {
			this.$trigger.click((e) => { this.toggle(); });
			this.$links.click((e) => { this.hide(); });
		}

		toggle() {
			if (this.$container.hasClass('is-active')) {
				this.hide();
			}
			else {
				this.show();
			}
		}

		show() {
			this.$container.addClass('is-active');
		}

		hide() {
			this.$container.removeClass('is-active');
		}

		toggleDropdown(e) {

			const $link = $(e.delegateTarget);

			if ($(window).width() < 900) {
				const $submenu = $link.siblings('.sub-menu');

				if ($submenu.is(":visible")) {
					$submenu.parent().removeClass('has-open');
				}
				else {
					$submenu.parent().addClass('has-open');
				}
				$submenu.stop().slideToggle(200);
			}
		}

	}

})(jQuery);


var mobileNavInit$1 = mobileNavInit;

var navInit;

(function ($) {

	const selectors = {
		navContainer: '.c-nav, .c-top-nav',
		langDropdown: '[data-lang-dropdown]',
		langDropdownTrigger: '[data-lang-dropdown-trigger]',
	};

	navInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new Nav(el);
		});
	};

	class Nav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();

		}
		init() {
			this.$items = $(this.$container).find('li');
			this.$items.filter((i, el) => {
				return ($(el).children('.sub-menu').children().length > 0);
			}).append('<div class="c-nav__item-arrow">');

			this.$langDropdown = $(selectors.langDropdown);
			this.$langDropdownTrigger = $(selectors.langDropdownTrigger);

		}

		bind() {
			const self = this;
			this.onHover = this.onHover.bind(this);
			this.onHoverOut = this.onHoverOut.bind(this);
			this.$items.hover(function (e) { self.onHover(this); }, function (e) { self.onHoverOut(this); });

			// this.$langDropdownTrigger.on('click', this.onlangDropdownTriggerClick.bind(this));
		}

		onHover(menuItem) {
			if ($(window).width() >= 900)
				$(menuItem).children('.sub-menu').stop().fadeIn();
		}

		onHoverOut(menuItem) {
			if ($(window).width() >= 900)
				$(menuItem).children('.sub-menu').stop().fadeOut();
		}

		onlangDropdownTriggerClick() {
			this.$langDropdown.toggle();
		}

	}

})(jQuery);


var navInit$1 = navInit;

var accordionInit;

(function ($) {

	const selectors = {
		wrap: '[data-accordions]',
		accordion: '[data-accordion]',
		trigger: '[data-accordion-trigger]',
		content: '[data-accordion-content]',
	};

	accordionInit = function () {
		$(selectors.wrap).each((i, el) => {
			new Accordion(el);
		});
	};

	class Accordion {
		constructor(element) {
			this.$wrap = $(element);

			this.init();


		}
		init() {
			this.$accordions = this.$wrap.find(selectors.accordion);
			this.$triggers = $(selectors.trigger, this.$accordions).not(this.$wrap.find(selectors.wrap).find(selectors.trigger));
			this.$contents = $(selectors.content, this.$accordions).not(this.$wrap.find(selectors.wrap).find(selectors.content));
			this.allowMultiple = this.$wrap.attr('data-allow-multiple') !== undefined;
			this.delay = this.$wrap.attr('data-delay') ? this.$wrap.attr('data-delay') : 0;

			this.bind();

			if (this.$wrap.attr('data-open-first') !== undefined) {
				this.$triggers.eq(0).trigger('click');
			}

		}

		bind() {

			const self = this;

			this.onTriggerClicked = this.onTriggerClicked.bind(this);
			this.$triggers.on('click', function (e) { e.preventDefault(); self.onTriggerClicked(this); });
		}

		onTriggerClicked(link) {
			var $acc = $(link).closest(selectors.accordion);
			$acc.hasClass('is-active') ? this.hide($acc) : this.show($acc);
		}

		show($acc) {

			if ($acc.hasClass('is-active')) return;

			const self = this;

			if (!this.allowMultiple) {
				setTimeout(() => {
					this.$accordions.not($acc).each((i, acc) => {
						self.hide($(acc));
					});

				}, self.delay);

			}

			$acc.addClass('is-active').find(this.$contents).stop().delay(self.delay).slideDown();

		}

		hide($acc) {
			if (!$acc.hasClass('is-active')) return;
			$acc.removeClass('is-active').find(this.$contents).stop().delay(self.delay).slideUp();
		}

	}

})(jQuery);


var accordionInit$1 = accordionInit;

var slickInit;

(function ($) {

	const selectors = {
		'prevArrow': '[data-slick-prev]',
		'nextArrow': '[data-slick-next]',
	};

	slickInit = function () {

		$(document).on('click', '.slick-cloned [data-fancybox]', function (e) {
			e.preventDefault();
			const $link = $(e.currentTarget);
			const $slide = $link.closest('.slick-slide');
			const $slides = $slide.siblings().not('.slick-cloned');
			const slideNum = ($slide.attr("data-slick-index") || 0) % ($slides.length);

			const $targetElem = $slides.eq(slideNum).find('[data-fancybox]');

			const event = new MouseEvent('click', {
				view: window,
				bubbles: true,
				cancelable: true
			});

			$targetElem.get(0).dispatchEvent(event);

		});

		new SlickSlider('.c-large-tiles__slider', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: true,
			arrows: false,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			slidesToShow: 1,
			infinite: true,
			// swipe: false,

			responsive: [
				{
					breakpoint: 600 - 1,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 900 - 1,
					settings: {
						slidesToShow: 3
					}
				},
			],

		});

		new SlickSlider('.c-product-tiles__slider', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: true,
			arrows: false,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			slidesToShow: 2,
			infinite: true,
			// swipe: false,

			responsive: [
				{
					breakpoint: 600 - 1,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 900 - 1,
					settings: {
						slidesToShow: 4
					}
				},
			],

		});

		new SlickSlider('.c-testimonials__slider--side', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: false,
			arrows: false,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			slidesToShow: 1,
			infinite: true,
			// swipe: false,

			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2
					}
				},
			],

		});
		new SlickSlider('.c-testimonials__slider--below', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: false,
			arrows: true,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			slidesToShow: 1,
			infinite: true,
			// swipe: false,

			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 3
					}
				},
			],

		});

		new SlickSlider('.c-text-media__media--slider', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: true,
			arrows: false,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			// swipe: false,
		});

		new SlickSlider('.c-configuration__slider', {
			autoplaySpeed: 5000,
			speed: 700,
			autoplay: true,
			dots: true,
			arrows: false,
			pauseOnHover: false,
			mobileFirst: true,
			swipeToSlide: true,
			// swipe: false,
		});



	};
	class SlickSlider {

		constructor(el, options) {

			this.$slider = $(el);

			this.events = options.events || false;
			delete options.events;

			this.options = options;

			if (this.$slider.length) {
				this.bind();
				this.init();
			}
		}

		bind() {
			this.onResize = this.onResize.bind(this);

			const $section = this.$slider.closest('section');
			const $navItems = $section.find('[data-slick-nav]');

			$(window).on('resize', this.onResize);

			const self = this;
			if (self.events) {
				$.each(self.events, (event, callback) => {
					self.$slider.on(event, callback);
				});
			}

			if ($navItems.length) {
				// Handle slide changes with afterChange event
				this.$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
					$section.find('[data-slick-nav]').removeClass('is-active');
					$section.find('[data-slick-nav="' + nextSlide + '"]').addClass('is-active');
				});

				// Add click handlers for navigation items
				$navItems.on('click', (e) => {
					e.preventDefault();
					const slideIndex = $(e.currentTarget).data('slick-nav');
					this.$slider.slick('slickGoTo', slideIndex);
					// $navItems.removeClass('is-active');
					// $(e.currentTarget).addClass('is-active');
				});

				// Set initial active state for first nav item
				$section.find('[data-slick-nav="0"]').addClass('is-active');
			}

		}

		init() {

			const $section = this.$slider.closest('section');


			if ($section.find(selectors.prevArrow)) {
				this.options.prevArrow = $section.find(selectors.prevArrow);
			}
			if ($section.find(selectors.nextArrow)) {
				this.options.nextArrow = $section.find(selectors.nextArrow);
			}

			this.$slider.slick(this.options);
		}

		onResize() {
			// console.log('hello');
			if (!this.$slider.hasClass('slick-initialized')) {
				this.init();
			}
		}


	}

})(jQuery);

var slickInit$1 = slickInit;

var tabsInit;

(function ($) {

	const selectors = {
		wrapper: '[data-tabs]',
		tabsWrapper: '[data-tabs-wrap]',
		links: '[data-tabs-link]',
		tabs: '[data-tabs-tab]',
		parent: '[data-tabs-link-parent]',
		parentItem: '> a'
	};

	tabsInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new Tabs(el);
		});
	};

	class Tabs {

		constructor(wrapper) {

			this.$wrapper = $(wrapper);

			if (this.$wrapper.length) {
				this.init();
			}

		}

		init() {

			this.$tabLinks = $(selectors.links, this.$wrapper);
			this.$tabsWrapper = $(selectors.tabsWrapper, this.$wrapper);
			this.$tabs = $(selectors.tabs, this.$wrapper);

			this.animate = true;
			this.duration = 400;
			this.allowAllClosed = this.$wrapper.attr('data-allow-all-closed') !== undefined;

			this.bind();

		}
		bind() {
			const self = this;

			self.$tabLinks.click(this.onTabLinkClicked.bind(this));

			$(document).on('hp-plugins-loaded', () => {
				const $target_tab = this.$tabLinks.filter('.is-active').length ? this.$tabLinks.filter('.is-active').first() : this.$tabLinks.first();
				if (!this.allowAllClosed) self.switchTab($target_tab.attr('href'), false);
			});

		}

		onTabLinkClicked(e) {
			e.preventDefault();

			const $link = $(e.delegateTarget);
			this.switchTab($link.attr('href'));
		}

		switchTab(targetId, animate) {
			if (!targetId) return;
			if (targetId == '#') return;

			const self = this;
			const $targetTab = self.$tabs.filter(targetId).eq(0);
			if (animate === undefined) animate = self.animate;

			if ($targetTab.hasClass('is-active')) {

				if (this.allowAllClosed) {

					self.$tabLinks.removeClass('is-active').closest(selectors.parent).find(selectors.parentItem).removeClass('is-active');
					self.$tabs.removeClass('is-active');

					if (animate) {
						const $curTab = self.$tabs.filter(':visible');

						$curTab.stop().animate({ 'height': 0 }, self.duration, function () {
							$(this).hide().css({ 'height': '' });
						});


					}
					else {
						self.$tabs.hide();
					}
				}

				return;

			}

			$(document).trigger('switching-to-tab', { targetId: targetId, $targetTab: $targetTab });

			self.$tabLinks.removeClass('is-active').closest(selectors.parent).removeClass('is-active').find(selectors.parentItem).removeClass('is-active');
			self.$tabLinks.filter((i, el) => { return $(el).attr('href') === targetId }).addClass('is-active').closest(selectors.parent).addClass('is-active').find(selectors.parentItem).addClass('is-active');

			// Remove data-disabled attribute from the next tab link
			const currentIndex = self.$tabLinks.index(self.$tabLinks.filter((i, el) => { return $(el).attr('href') === targetId }));
			const $nextTabLink = self.$tabLinks.eq(currentIndex + 1);
			if ($nextTabLink.length) {
				$nextTabLink.removeAttr('data-disabled');
			}

			self.$tabs.removeClass('is-active');
			$targetTab.addClass('is-active');

			// Scroll to top of tab if it's out of view
			const tabOffset = self.$wrapper.offset().top;
			const windowScrollTop = $(window).scrollTop();
			const headerHeight = $('header').outerHeight() || 0; // Adjust if you have a fixed header

			if (tabOffset < windowScrollTop || tabOffset > (windowScrollTop + $(window).height())) {
				$('html, body').animate({
					scrollTop: tabOffset - headerHeight - 20 // 20px extra padding
				}, animate ? self.duration : 0);
			}

			if (animate) {

				const $curTab = self.$tabs.filter(':visible');
				const curHeight = $curTab.length ? $curTab.eq(0).outerHeight() : 0;

				self.$tabsWrapper.addClass('is-changing');

				$curTab.css('position', 'absolute');
				$targetTab.css({ 'opacity': 0, 'height': '' }).show();

				if ($targetTab.find('.slick-initialized').length && typeof $.fn.slick !== 'undefined') {
					$targetTab.find('.slick-initialized').slick('setPosition');
				}

				const newHeight = $targetTab.outerHeight();

				$curTab.stop().animate({ 'opacity': 0 }, self.duration, function () {
					$(this).hide().css({ 'position': '', opacity: '' });
				});

				$targetTab.css('height', curHeight).stop().animate({ 'height': newHeight, 'opacity': 1 }, self.duration, function () {
					$(this).css({ 'height': '', 'opacity': '' });
					self.$tabsWrapper.removeClass('is-changing');
				});

			}
			else {
				self.$tabs.hide();
				$targetTab.show();
			}



		}

	}

})(jQuery);


var tabsInit$1 = tabsInit;

var fancyboxInit;

(function ($) {
	fancyboxInit = function () {

		$('.flexible-content a[href*="youtube.com/watch"]:not([data-fancybox])').attr('data-fancybox', '');
		$('.gallery a').attr('data-fancybox', 'post-gallery');
		$('.c-post-flexible .c-post-text-section a').filter(function () {
			return $(this).children('img').length > 0;
		}).attr('data-fancybox', 'post-gallery');

		if (typeof (Fancybox) !== 'undefined') {
			Fancybox.bind("[data-fancybox]:not(.is-cloned)", {
				backFocus: false,
				Thumbs: {
					type: "classic",
				},
			});
		}

	};

})(jQuery);

var fancyboxInit$1 = fancyboxInit;

var faqInit;

(function ($) {

	const selectors = {
		wrap: '[data-faq]',
		search: '[data-faq-search]',
		searchItem: '[data-faq-search-item]',
		searchContent: '[data-faq-search-content]',
		group: '[data-category-group]'

	};

	faqInit = function () {
		$(selectors.wrap).each((i, el) => {
			new FAQ(el);
		});
	};

	class FAQ {
		constructor(element) {
			this.$wrap = $(element);

			this.init();
			this.bind();

			this.initSearchable();

		}
		init() {
			this.$searchInput = $(selectors.search, this.$wrap);
			this.$groups = $(selectors.group, this.$wrap);
		}

		bind() {
		}

		initSearchable() {
			this.$wrap.searchable({
				searchField: this.$searchInput,
				selector: selectors.searchItem,

				searchType: 'default',
				childSelector: selectors.searchContent,

				onSearchActive: this.onSearchActive.bind(this),
				onSearchEmpty: this.onSearchEmpty.bind(this),

				show: this.showItem.bind(this),
				hide: this.hideItem.bind(this),
			});
		}
		onSearchEmpty() {
			this.$wrap.removeClass('is-search-active');
		}

		onSearchActive() {
			this.$wrap.addClass('is-search-active');

			this.$groups.each((i, group) => {

				setTimeout(_ => {
					const $group = $(group);
					const $items = $group.find(selectors.searchItem);
					const num_visible = $items.filter('.is-visible').length;

					$group.attr('data-num-results', num_visible);

				}, 50);


			});


		}


		showItem($item) {
			$item.removeClass('is-hidden').addClass('is-visible').show();
		}
		hideItem($item) {
			$item.removeClass('is-visible').addClass('is-hidden').hide();
		}

	}

})(jQuery);


var faqInit$1 = faqInit;

const countriesData = [
	{
		countryNameEn: "Andorra",
		countryNameLocal: "Andorra",
		countryCode: "AD",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ca",
		officialLanguageNameEn: "Catalan, Valencian",
		officialLanguageNameLocal: "Català, Valencià",
		countryCallingCode: "376",
		areaCodes: [],
		region: "Europe",
		flag: "🇦🇩",
	},
	{
		countryNameEn: "Afghanistan",
		countryNameLocal: "د افغانستان اسلامي دولتدولت اسلامی افغانستان, جمهوری اسلامی افغانستان",
		countryCode: "AF",
		currencyCode: "AFN",
		currencyNameEn: "Afghan afghani",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fa",
		officialLanguageNameEn: "Persian",
		officialLanguageNameLocal: "فارسی",
		countryCallingCode: "93",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇦🇫",
	},
	{
		countryNameEn: "Antigua and Barbuda",
		countryNameLocal: "Antigua and Barbuda",
		countryCode: "AG",
		currencyCode: "XCD",
		currencyNameEn: "East Caribbean dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1268",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇦🇬",
	},
	{
		countryNameEn: "Anguilla",
		countryNameLocal: "Anguilla",
		countryCode: "AI",
		currencyCode: "XCD",
		currencyNameEn: "East Caribbean dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1264",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇦🇮",
	},
	{
		countryNameEn: "Albania",
		countryNameLocal: "Shqipëria",
		countryCode: "AL",
		currencyCode: "ALL",
		currencyNameEn: "Albanian lek",
		tinType: "NIPT",
		tinName: "Numri i Identifikimit për Personin e Tatueshëm",
		officialLanguageCode: "sq",
		officialLanguageNameEn: "Albanian",
		officialLanguageNameLocal: "Shqip",
		countryCallingCode: "355",
		areaCodes: [],
		region: "Europe",
		flag: "🇦🇱",
	},
	{
		countryNameEn: "Armenia",
		countryNameLocal: "Հայաստան",
		countryCode: "AM",
		currencyCode: "AMD",
		currencyNameEn: "Armenian dram",
		tinType: "",
		tinName: "",
		officialLanguageCode: "hy",
		officialLanguageNameEn: "Armenian",
		officialLanguageNameLocal: "Հայերեն",
		countryCallingCode: "374",
		areaCodes: [],
		region: "Europe",
		flag: "🇦🇲",
	},
	{
		countryNameEn: "Angola",
		countryNameLocal: "Angola",
		countryCode: "AO",
		currencyCode: "AOA",
		currencyNameEn: "Angolan kwanza",
		tinType: "",
		tinName: "",
		officialLanguageCode: "pt",
		officialLanguageNameEn: "Portuguese",
		officialLanguageNameLocal: "Português",
		countryCallingCode: "244",
		areaCodes: [],
		region: "Africa",
		flag: "🇦🇴",
	},
	{
		countryNameEn: "Antarctica",
		countryNameLocal: "Antarctica, Antártico, Antarctique, Антарктике",
		countryCode: "AQ",
		currencyCode: "",
		currencyNameEn: "",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "672",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇦🇶",
	},
	{
		countryNameEn: "Argentina",
		countryNameLocal: "Argentina",
		countryCode: "AR",
		currencyCode: "ARS",
		currencyNameEn: "Argentine peso",
		tinType: "CUIT",
		tinName: "Código Único de Identificación Tributaria",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "54",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇦🇷",
	},
	{
		countryNameEn: "American Samoa",
		countryNameLocal: "American Samoa",
		countryCode: "AS",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1684",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇦🇸",
	},
	{
		countryNameEn: "Austria",
		countryNameLocal: "Österreich",
		countryCode: "AT",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "UID",
		tinName: "Umsatzsteuer-Identifikationsnummer",
		officialLanguageCode: "de",
		officialLanguageNameEn: "German",
		officialLanguageNameLocal: "Deutsch",
		countryCallingCode: "43",
		areaCodes: [],
		region: "Europe",
		flag: "🇦🇹",
	},
	{
		countryNameEn: "Australia",
		countryNameLocal: "Australia",
		countryCode: "AU",
		currencyCode: "AUD",
		currencyNameEn: "Australian dollar",
		tinType: "ABN",
		tinName: "Australian Business Number",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "61",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇦🇺",
	},
	{
		countryNameEn: "Aruba",
		countryNameLocal: "Aruba",
		countryCode: "AW",
		currencyCode: "AWG",
		currencyNameEn: "Aruban florin",
		tinType: "",
		tinName: "",
		officialLanguageCode: "nl",
		officialLanguageNameEn: "Dutch, Flemish",
		officialLanguageNameLocal: "Nederlands, Vlaams",
		countryCallingCode: "297",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇦🇼",
	},
	{
		countryNameEn: "Åland Islands",
		countryNameLocal: "Åland",
		countryCode: "AX",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "sv",
		officialLanguageNameEn: "Swedish",
		officialLanguageNameLocal: "Svenska",
		countryCallingCode: "358",
		areaCodes: [],
		region: "Europe",
		flag: "🇦🇽",
	},
	{
		countryNameEn: "Azerbaijan",
		countryNameLocal: "Azərbaycan",
		countryCode: "AZ",
		currencyCode: "AZN",
		currencyNameEn: "Azerbaijani manat",
		tinType: "",
		tinName: "",
		officialLanguageCode: "az",
		officialLanguageNameEn: "Azerbaijani",
		officialLanguageNameLocal: "azərbaycan dili",
		countryCallingCode: "994",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇦🇿",
	},
	{
		countryNameEn: "Bosnia and Herzegovina",
		countryNameLocal: "Bosna i Hercegovina",
		countryCode: "BA",
		currencyCode: "BAM",
		currencyNameEn: "Bosnia and Herzegovina convertible mark",
		tinType: "",
		tinName: "",
		officialLanguageCode: "bs",
		officialLanguageNameEn: "Bosnian",
		officialLanguageNameLocal: "bosanski jezik",
		countryCallingCode: "387",
		areaCodes: [],
		region: "Europe",
		flag: "🇧🇦",
	},
	{
		countryNameEn: "Barbados",
		countryNameLocal: "Barbados",
		countryCode: "BB",
		currencyCode: "BBD",
		currencyNameEn: "Barbados dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1246",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇧🇧",
	},
	{
		countryNameEn: "Bangladesh",
		countryNameLocal: "গণপ্রজাতন্ত্রী বাংলাদেশ",
		countryCode: "BD",
		currencyCode: "BDT",
		currencyNameEn: "Bangladeshi taka",
		tinType: "",
		tinName: "",
		officialLanguageCode: "bn",
		officialLanguageNameEn: "Bengali",
		officialLanguageNameLocal: "বাংলা",
		countryCallingCode: "880",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇧🇩",
	},
	{
		countryNameEn: "Belgium",
		countryNameLocal: "België, Belgique, Belgien",
		countryCode: "BE",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "n° TVABTW-nr Mwst-nr",
		tinName: "BTW identificatienummer / Numéro de TVA",
		officialLanguageCode: "nl",
		officialLanguageNameEn: "Dutch, Flemish",
		officialLanguageNameLocal: "Nederlands, Vlaams",
		countryCallingCode: "32",
		areaCodes: [],
		region: "Europe",
		flag: "🇧🇪",
	},
	{
		countryNameEn: "Burkina Faso",
		countryNameLocal: "Burkina Faso",
		countryCode: "BF",
		currencyCode: "XOF",
		currencyNameEn: "CFA franc BCEAO",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "226",
		areaCodes: [],
		region: "Africa",
		flag: "🇧🇫",
	},
	{
		countryNameEn: "Bulgaria",
		countryNameLocal: "България",
		countryCode: "BG",
		currencyCode: "BGN",
		currencyNameEn: "Bulgarian lev",
		tinType: "ДДС номер",
		tinName: "Идентификационен номер по ДДС",
		officialLanguageCode: "bg",
		officialLanguageNameEn: "Bulgarian",
		officialLanguageNameLocal: "български език",
		countryCallingCode: "359",
		areaCodes: [],
		region: "Europe",
		flag: "🇧🇬",
	},
	{
		countryNameEn: "Bahrain",
		countryNameLocal: "البحرين",
		countryCode: "BH",
		currencyCode: "BHD",
		currencyNameEn: "Bahraini dinar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "973",
		areaCodes: [],
		region: "Arab States",
		flag: "🇧🇭",
	},
	{
		countryNameEn: "Burundi",
		countryNameLocal: "Burundi",
		countryCode: "BI",
		currencyCode: "BIF",
		currencyNameEn: "Burundian franc",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "257",
		areaCodes: [],
		region: "Africa",
		flag: "🇧🇮",
	},
	{
		countryNameEn: "Benin",
		countryNameLocal: "Bénin",
		countryCode: "BJ",
		currencyCode: "XOF",
		currencyNameEn: "CFA franc BCEAO",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "229",
		areaCodes: [],
		region: "Africa",
		flag: "🇧🇯",
	},
	{
		countryNameEn: "Saint Barthélemy",
		countryNameLocal: "Saint-Barthélemy",
		countryCode: "BL",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "590",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇧🇱",
	},
	{
		countryNameEn: "Bermuda",
		countryNameLocal: "Bermuda",
		countryCode: "BM",
		currencyCode: "BMD",
		currencyNameEn: "Bermudian dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1441",
		areaCodes: [],
		region: "North America",
		flag: "🇧🇲",
	},
	{
		countryNameEn: "Brunei Darussalam",
		countryNameLocal: "Brunei Darussalam",
		countryCode: "BN",
		currencyCode: "BND",
		currencyNameEn: "Brunei dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ms",
		officialLanguageNameEn: "Malay",
		officialLanguageNameLocal: "Bahasa Melayu, بهاس ملايو‎",
		countryCallingCode: "673",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇧🇳",
	},
	{
		countryNameEn: "Bolivia (Plurinational State of)",
		countryNameLocal: "Bolivia, Bulibiya, Volívia, Wuliwya",
		countryCode: "BO",
		currencyCode: "BOP",
		currencyNameEn: "",
		tinType: "NIT",
		tinName: "Número de Identificación Tributaria",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "591",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇧🇴",
	},
	{
		countryNameEn: "Bonaire, Sint Eustatius and Saba",
		countryNameLocal: "Caribisch Nederland",
		countryCode: "BQ",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "nl",
		officialLanguageNameEn: "Dutch, Flemish",
		officialLanguageNameLocal: "Nederlands, Vlaams",
		countryCallingCode: "5997",
		areaCodes: [],
		region: "Unknown",
		flag: "🇧🇶",
	},
	{
		countryNameEn: "Brazil",
		countryNameLocal: "Brasil",
		countryCode: "BR",
		currencyCode: "BRL",
		currencyNameEn: "Brazilian real",
		tinType: "CNPJ",
		tinName: "Cadastro Nacional de Pessoa Jurídica",
		officialLanguageCode: "pt",
		officialLanguageNameEn: "Portuguese",
		officialLanguageNameLocal: "Português",
		countryCallingCode: "55",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇧🇷",
	},
	{
		countryNameEn: "Bhutan",
		countryNameLocal: "འབྲུག་ཡུལ",
		countryCode: "BT",
		currencyCode: "BTN",
		currencyNameEn: "Bhutanese ngultrum",
		tinType: "",
		tinName: "",
		officialLanguageCode: "dz",
		officialLanguageNameEn: "Dzongkha",
		officialLanguageNameLocal: "རྫོང་ཁ",
		countryCallingCode: "975",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇧🇹",
	},
	{
		countryNameEn: "Bouvet Island",
		countryNameLocal: "Bouvetøya",
		countryCode: "BV",
		currencyCode: "NOK",
		currencyNameEn: "Norwegian krone",
		tinType: "",
		tinName: "",
		officialLanguageCode: "no",
		officialLanguageNameEn: "Norwegian",
		officialLanguageNameLocal: "Norsk",
		countryCallingCode: "47",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇧🇻",
	},
	{
		countryNameEn: "Botswana",
		countryNameLocal: "Botswana",
		countryCode: "BW",
		currencyCode: "BWP",
		currencyNameEn: "Botswana pula",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "267",
		areaCodes: [],
		region: "Africa",
		flag: "🇧🇼",
	},
	{
		countryNameEn: "Belarus",
		countryNameLocal: "Беларусь",
		countryCode: "BY",
		currencyCode: "BYR",
		currencyNameEn: "",
		tinType: "УНП (UNP)",
		tinName: "Учетный номер плательщика",
		officialLanguageCode: "be",
		officialLanguageNameEn: "Belarusian",
		officialLanguageNameLocal: "беларуская мова",
		countryCallingCode: "375",
		areaCodes: [],
		region: "Europe",
		flag: "🇧🇾",
	},
	{
		countryNameEn: "Belize",
		countryNameLocal: "Belize",
		countryCode: "BZ",
		currencyCode: "BZD",
		currencyNameEn: "Belize dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "501",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇧🇿",
	},
	{
		countryNameEn: "Canada",
		countryNameLocal: "Canada",
		countryCode: "CA",
		currencyCode: "CAD",
		currencyNameEn: "Canadian dollar",
		tinType: "BN / NE",
		tinName: "Business Number",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1",
		areaCodes: [
			"403",
			"587",
			"780",
			"825",
			"236",
			"250",
			"604",
			"672",
			"778",
			"204",
			"431",
			"506",
			"709",
			"782",
			"902",
			"226",
			"249",
			"289",
			"343",
			"365",
			"416",
			"437",
			"519",
			"548",
			"613",
			"647",
			"705",
			"807",
			"905",
			"367",
			"418",
			"438",
			"450",
			"514",
			"579",
			"581",
			"819",
			"873",
			"306",
			"639",
			"867",
		],
		region: "North America",
		flag: "🇨🇦",
	},
	{
		countryNameEn: "Switzerland",
		countryNameLocal: "Schweiz, Suisse, Svizzera, Svizra",
		countryCode: "CH",
		currencyCode: "CHF",
		currencyNameEn: "Swiss franc",
		tinType: "MWST/TVA/IVA",
		tinName: "Mehrwertsteuernummer",
		officialLanguageCode: "de",
		officialLanguageNameEn: "German",
		officialLanguageNameLocal: "Deutsch",
		countryCallingCode: "41",
		areaCodes: [],
		region: "Europe",
		flag: "🇨🇭",
	},
	{
		countryNameEn: "Côte d'Ivoire",
		countryNameLocal: "Côte d'Ivoire",
		countryCode: "CI",
		currencyCode: "XOF",
		currencyNameEn: "CFA franc BCEAO",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "225",
		areaCodes: [],
		region: "Africa",
		flag: "🇨🇮",
	},
	{
		countryNameEn: "Chile",
		countryNameLocal: "Chile",
		countryCode: "CL",
		currencyCode: "CLP",
		currencyNameEn: "Chilean peso",
		tinType: "RUT",
		tinName: "Rol Único Tributario",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "56",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇨🇱",
	},
	{
		countryNameEn: "Cameroon",
		countryNameLocal: "Cameroun, Cameroon",
		countryCode: "CM",
		currencyCode: "XAF",
		currencyNameEn: "CFA franc BEAC",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "237",
		areaCodes: [],
		region: "Africa",
		flag: "🇨🇲",
	},
	{
		countryNameEn: "China",
		countryNameLocal: "中国",
		countryCode: "CN",
		currencyCode: "CNY",
		currencyNameEn: "Renminbi (Chinese) yuan",
		tinType: "",
		tinName: "",
		officialLanguageCode: "zh-hans",
		officialLanguageNameEn: "",
		officialLanguageNameLocal: "",
		countryCallingCode: "86",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇨🇳",
	},
	{
		countryNameEn: "Colombia",
		countryNameLocal: "Colombia",
		countryCode: "CO",
		currencyCode: "COP",
		currencyNameEn: "Colombian peso",
		tinType: "NIT",
		tinName: "Número De Identificación Tributaria",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "57",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇨🇴",
	},
	{
		countryNameEn: "Costa Rica",
		countryNameLocal: "Costa Rica",
		countryCode: "CR",
		currencyCode: "CRC",
		currencyNameEn: "Costa Rican colon",
		tinType: "",
		tinName: "Cédula Jurídica",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "506",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇨🇷",
	},
	{
		countryNameEn: "Cuba",
		countryNameLocal: "Cuba",
		countryCode: "CU",
		currencyCode: "CUC",
		currencyNameEn: "Cuban convertible peso",
		tinType: "",
		tinName: "",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "53",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇨🇺",
	},
	{
		countryNameEn: "Cabo Verde",
		countryNameLocal: "Cabo Verde",
		countryCode: "CV",
		currencyCode: "CVE",
		currencyNameEn: "Cape Verdean escudo",
		tinType: "",
		tinName: "",
		officialLanguageCode: "pt",
		officialLanguageNameEn: "Portuguese",
		officialLanguageNameLocal: "Português",
		countryCallingCode: "238",
		areaCodes: [],
		region: "Africa",
		flag: "🇨🇻",
	},
	{
		countryNameEn: "Curaçao",
		countryNameLocal: "Curaçao",
		countryCode: "CW",
		currencyCode: "ANG",
		currencyNameEn: "Netherlands Antillean guilder",
		tinType: "",
		tinName: "",
		officialLanguageCode: "nl",
		officialLanguageNameEn: "Dutch, Flemish",
		officialLanguageNameLocal: "Nederlands, Vlaams",
		countryCallingCode: "599",
		areaCodes: [],
		region: "Unknown",
		flag: "🇨🇼",
	},
	{
		countryNameEn: "Christmas Island",
		countryNameLocal: "Christmas Island",
		countryCode: "CX",
		currencyCode: "AUD",
		currencyNameEn: "Australian dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "61",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇨🇽",
	},
	{
		countryNameEn: "Cyprus",
		countryNameLocal: "Κύπρος, Kibris",
		countryCode: "CY",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "ΦΠΑ",
		tinName: "Αριθμός Εγγραφής Φ.Π.Α.",
		officialLanguageCode: "el",
		officialLanguageNameEn: "Greek, Modern (1453-)",
		officialLanguageNameLocal: "ελληνικά",
		countryCallingCode: "357",
		areaCodes: [],
		region: "Europe",
		flag: "🇨🇾",
	},
	{
		countryNameEn: "Germany",
		countryNameLocal: "Deutschland",
		countryCode: "DE",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "USt-IdNr.",
		tinName: "Umsatzsteuer-Identifikationsnummer",
		officialLanguageCode: "de",
		officialLanguageNameEn: "German",
		officialLanguageNameLocal: "Deutsch",
		countryCallingCode: "49",
		areaCodes: [],
		region: "Europe",
		flag: "🇩🇪",
	},
	{
		countryNameEn: "Djibouti",
		countryNameLocal: "Djibouti, جيبوتي, Jabuuti, Gabuutih",
		countryCode: "DJ",
		currencyCode: "DJF",
		currencyNameEn: "Djiboutian franc",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "253",
		areaCodes: [],
		region: "Arab States",
		flag: "🇩🇯",
	},
	{
		countryNameEn: "Denmark",
		countryNameLocal: "Danmark",
		countryCode: "DK",
		currencyCode: "DKK",
		currencyNameEn: "Danish krone",
		tinType: "CVR",
		tinName: "Momsregistreringsnummer",
		officialLanguageCode: "da",
		officialLanguageNameEn: "Danish",
		officialLanguageNameLocal: "dansk",
		countryCallingCode: "45",
		areaCodes: [],
		region: "Europe",
		flag: "🇩🇰",
	},
	{
		countryNameEn: "Dominica",
		countryNameLocal: "Dominica",
		countryCode: "DM",
		currencyCode: "XCD",
		currencyNameEn: "East Caribbean dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "767",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇩🇲",
	},
	{
		countryNameEn: "Algeria",
		countryNameLocal: "الجزائر",
		countryCode: "DZ",
		currencyCode: "DZD",
		currencyNameEn: "Algerian dinar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "213",
		areaCodes: [],
		region: "Arab States",
		flag: "🇩🇿",
	},
	{
		countryNameEn: "Ecuador",
		countryNameLocal: "Ecuador",
		countryCode: "EC",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "RUC",
		tinName: "Número de Registro Unico de Contribuyentes",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "593",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇪🇨",
	},
	{
		countryNameEn: "Estonia",
		countryNameLocal: "Eesti",
		countryCode: "EE",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "KMKR",
		tinName: "Käibemaksukohustuslase number",
		officialLanguageCode: "et",
		officialLanguageNameEn: "Estonian",
		officialLanguageNameLocal: "eesti, eesti keel",
		countryCallingCode: "372",
		areaCodes: [],
		region: "Europe",
		flag: "🇪🇪",
	},
	{
		countryNameEn: "Egypt",
		countryNameLocal: "مصر",
		countryCode: "EG",
		currencyCode: "EGP",
		currencyNameEn: "Egyptian pound",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "20",
		areaCodes: [],
		region: "Arab States",
		flag: "🇪🇬",
	},
	{
		countryNameEn: "Western Sahara",
		countryNameLocal: "Sahara Occidental",
		countryCode: "EH",
		currencyCode: "MAD",
		currencyNameEn: "Moroccan dirham",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "212",
		areaCodes: [],
		region: "Africa",
		flag: "🇪🇭",
	},
	{
		countryNameEn: "Eritrea",
		countryNameLocal: "ኤርትራ, إرتريا, Eritrea",
		countryCode: "ER",
		currencyCode: "ERN",
		currencyNameEn: "Eritrean nakfa",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ti",
		officialLanguageNameEn: "Tigrinya",
		officialLanguageNameLocal: "ትግርኛ",
		countryCallingCode: "291",
		areaCodes: [],
		region: "Africa",
		flag: "🇪🇷",
	},
	{
		countryNameEn: "Spain",
		countryNameLocal: "España",
		countryCode: "ES",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "NIF (CIF)",
		tinName: "Número de Identificación Fiscal (formerly named Código de Identificación Fiscal)",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "34",
		areaCodes: [],
		region: "Europe",
		flag: "🇪🇸",
	},
	{
		countryNameEn: "Ethiopia",
		countryNameLocal: "ኢትዮጵያ, Itoophiyaa",
		countryCode: "ET",
		currencyCode: "ETB",
		currencyNameEn: "Ethiopian birr",
		tinType: "",
		tinName: "",
		officialLanguageCode: "am",
		officialLanguageNameEn: "Amharic",
		officialLanguageNameLocal: "አማርኛ",
		countryCallingCode: "251",
		areaCodes: [],
		region: "Africa",
		flag: "🇪🇹",
	},
	{
		countryNameEn: "Finland",
		countryNameLocal: "Suomi",
		countryCode: "FI",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "ALV nro",
		tinName: "Arvonlisäveronumero",
		officialLanguageCode: "fi",
		officialLanguageNameEn: "Finnish",
		officialLanguageNameLocal: "suomi, suomen kieli",
		countryCallingCode: "358",
		areaCodes: [],
		region: "Europe",
		flag: "🇫🇮",
	},
	{
		countryNameEn: "Fiji",
		countryNameLocal: "Fiji",
		countryCode: "FJ",
		currencyCode: "FJD",
		currencyNameEn: "Fiji dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "679",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇫🇯",
	},
	{
		countryNameEn: "Micronesia (Federated States of)",
		countryNameLocal: "Micronesia",
		countryCode: "FM",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "691",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇫🇲",
	},
	{
		countryNameEn: "France",
		countryNameLocal: "France",
		countryCode: "FR",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "n° TVA",
		tinName: "Numéro d'identification à la taxe sur la valeur ajoutée / Numéro de TVA intracommunautaire",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "33",
		areaCodes: [],
		region: "Europe",
		flag: "🇫🇷",
	},
	{
		countryNameEn: "Gabon",
		countryNameLocal: "Gabon",
		countryCode: "GA",
		currencyCode: "XAF",
		currencyNameEn: "CFA franc BEAC",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "241",
		areaCodes: [],
		region: "Africa",
		flag: "🇬🇦",
	},
	{
		countryNameEn: "Grenada",
		countryNameLocal: "Grenada",
		countryCode: "GD",
		currencyCode: "XCD",
		currencyNameEn: "East Caribbean dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1473",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇬🇩",
	},
	{
		countryNameEn: "Georgia",
		countryNameLocal: "საქართველო",
		countryCode: "GE",
		currencyCode: "GEL",
		currencyNameEn: "Georgian lari",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ka",
		officialLanguageNameEn: "Georgian",
		officialLanguageNameLocal: "ქართული",
		countryCallingCode: "995",
		areaCodes: [],
		region: "Europe",
		flag: "🇬🇪",
	},
	{
		countryNameEn: "French Guiana",
		countryNameLocal: "Guyane française",
		countryCode: "GF",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "594",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇬🇫",
	},
	{
		countryNameEn: "Guernsey",
		countryNameLocal: "Guernsey",
		countryCode: "GG",
		currencyCode: "GBP",
		currencyNameEn: "Pound sterling",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "44",
		areaCodes: [],
		region: "Europe",
		flag: "🇬🇬",
	},
	{
		countryNameEn: "Ghana",
		countryNameLocal: "Ghana",
		countryCode: "GH",
		currencyCode: "GHS",
		currencyNameEn: "Ghanaian cedi",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "233",
		areaCodes: [],
		region: "Africa",
		flag: "🇬🇭",
	},
	{
		countryNameEn: "Gibraltar",
		countryNameLocal: "Gibraltar",
		countryCode: "GI",
		currencyCode: "GIP",
		currencyNameEn: "Gibraltar pound",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "350",
		areaCodes: [],
		region: "Europe",
		flag: "🇬🇮",
	},
	{
		countryNameEn: "Greenland",
		countryNameLocal: "Kalaallit Nunaat, Grønland",
		countryCode: "GL",
		currencyCode: "DKK",
		currencyNameEn: "Danish krone",
		tinType: "",
		tinName: "",
		officialLanguageCode: "kl",
		officialLanguageNameEn: "Kalaallisut, Greenlandic",
		officialLanguageNameLocal: "kalaallisut, kalaallit oqaasii",
		countryCallingCode: "299",
		areaCodes: [],
		region: "Europe",
		flag: "🇬🇱",
	},
	{
		countryNameEn: "Guinea",
		countryNameLocal: "Guinée",
		countryCode: "GN",
		currencyCode: "GNF",
		currencyNameEn: "Guinean franc",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "224",
		areaCodes: [],
		region: "Africa",
		flag: "🇬🇳",
	},
	{
		countryNameEn: "Guadeloupe",
		countryNameLocal: "Guadeloupe",
		countryCode: "GP",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "590",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇬🇵",
	},
	{
		countryNameEn: "Equatorial Guinea",
		countryNameLocal: "Guiena ecuatorial, Guinée équatoriale, Guiné Equatorial",
		countryCode: "GQ",
		currencyCode: "XAF",
		currencyNameEn: "CFA franc BEAC",
		tinType: "",
		tinName: "",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "240",
		areaCodes: [],
		region: "Africa",
		flag: "🇬🇶",
	},
	{
		countryNameEn: "Greece",
		countryNameLocal: "Ελλάδα",
		countryCode: "GR",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "el",
		officialLanguageNameEn: "Greek, Modern (1453-)",
		officialLanguageNameLocal: "ελληνικά",
		countryCallingCode: "30",
		areaCodes: [],
		region: "Europe",
		flag: "🇬🇷",
	},
	{
		countryNameEn: "South Georgia and the South Sandwich Islands",
		countryNameLocal: "South Georgia and the South Sandwich Islands",
		countryCode: "GS",
		currencyCode: "",
		currencyNameEn: "",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "500",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇬🇸",
	},
	{
		countryNameEn: "Guatemala",
		countryNameLocal: "Guatemala",
		countryCode: "GT",
		currencyCode: "GTQ",
		currencyNameEn: "Guatemalan quetzal",
		tinType: "NIT",
		tinName: "Número de Identificación Tributaria",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "502",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇬🇹",
	},
	{
		countryNameEn: "Guam",
		countryNameLocal: "Guam, Guåhån",
		countryCode: "GU",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇬🇺",
	},
	{
		countryNameEn: "Guinea-Bissau",
		countryNameLocal: "Guiné-Bissau",
		countryCode: "GW",
		currencyCode: "XOF",
		currencyNameEn: "CFA franc BCEAO",
		tinType: "",
		tinName: "",
		officialLanguageCode: "pt",
		officialLanguageNameEn: "Portuguese",
		officialLanguageNameLocal: "Português",
		countryCallingCode: "245",
		areaCodes: [],
		region: "Africa",
		flag: "🇬🇼",
	},
	{
		countryNameEn: "Guyana",
		countryNameLocal: "Guyana",
		countryCode: "GY",
		currencyCode: "GYD",
		currencyNameEn: "Guyanese dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "592",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇬🇾",
	},
	{
		countryNameEn: "Hong Kong",
		countryNameLocal: "香港, Hong Kong",
		countryCode: "HK",
		currencyCode: "HKD",
		currencyNameEn: "Hong Kong dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "zh-hant",
		officialLanguageNameEn: "",
		officialLanguageNameLocal: "",
		countryCallingCode: "852",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇭🇰",
	},
	{
		countryNameEn: "Honduras",
		countryNameLocal: "Honduras",
		countryCode: "HN",
		currencyCode: "HNL",
		currencyNameEn: "Honduran lempira",
		tinType: "RTN",
		tinName: "Registro Tributario Nacional",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "504",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇭🇳",
	},
	{
		countryNameEn: "Croatia",
		countryNameLocal: "Hrvatska",
		countryCode: "HR",
		currencyCode: "HRK",
		currencyNameEn: "Croatian kuna",
		tinType: "PDV-ID; OIB",
		tinName: "PDV Id. Broj OIB",
		officialLanguageCode: "hr",
		officialLanguageNameEn: "Croatian",
		officialLanguageNameLocal: "hrvatski jezik",
		countryCallingCode: "385",
		areaCodes: [],
		region: "Europe",
		flag: "🇭🇷",
	},
	{
		countryNameEn: "Haiti",
		countryNameLocal: "Haïti, Ayiti",
		countryCode: "HT",
		currencyCode: "HTG",
		currencyNameEn: "Haitian gourde",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "509",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇭🇹",
	},
	{
		countryNameEn: "Hungary",
		countryNameLocal: "Magyarország",
		countryCode: "HU",
		currencyCode: "HUF",
		currencyNameEn: "Hungarian forint",
		tinType: "ANUM",
		tinName: "Közösségi adószám",
		officialLanguageCode: "hu",
		officialLanguageNameEn: "Hungarian",
		officialLanguageNameLocal: "magyar",
		countryCallingCode: "36",
		areaCodes: [],
		region: "Europe",
		flag: "🇭🇺",
	},
	{
		countryNameEn: "Indonesia",
		countryNameLocal: "Indonesia",
		countryCode: "ID",
		currencyCode: "IDR",
		currencyNameEn: "Indonesian rupiah",
		tinType: "NPWP",
		tinName: "Nomor Pokok Wajib Pajak",
		officialLanguageCode: "id",
		officialLanguageNameEn: "Indonesian",
		officialLanguageNameLocal: "Bahasa Indonesia",
		countryCallingCode: "62",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇮🇩",
	},
	{
		countryNameEn: "Ireland",
		countryNameLocal: "Ireland, Éire",
		countryCode: "IE",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "VAT or CBL",
		tinName: "Value added tax identification no.",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "353",
		areaCodes: [],
		region: "Europe",
		flag: "🇮🇪",
	},
	{
		countryNameEn: "Israel",
		countryNameLocal: "ישראל",
		countryCode: "IL",
		currencyCode: "ILS",
		currencyNameEn: "Israeli new shekel",
		tinType: "",
		tinName: "מס' עוסק מורשה / ח\"פ",
		officialLanguageCode: "he",
		officialLanguageNameEn: "Hebrew",
		officialLanguageNameLocal: "עברית",
		countryCallingCode: "972",
		areaCodes: [],
		region: "Europe",
		flag: "🇮🇱",
	},
	{
		countryNameEn: "Isle of Man",
		countryNameLocal: "Isle of Man",
		countryCode: "IM",
		currencyCode: "GBP",
		currencyNameEn: "Pound sterling",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "44",
		areaCodes: [],
		region: "Europe",
		flag: "🇮🇲",
	},
	{
		countryNameEn: "India",
		countryNameLocal: "भारत, India",
		countryCode: "IN",
		currencyCode: "INR",
		currencyNameEn: "Indian rupee",
		tinType: "VAT TIN / CST TIN",
		tinName: "Value Added Tax - Taxpayer Identification Number / Central Sales Tax - Taxpayer Identification Number (In most states)Not applicable",
		officialLanguageCode: "hi",
		officialLanguageNameEn: "Hindi",
		officialLanguageNameLocal: "हिन्दी, हिंदी",
		countryCallingCode: "91",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇮🇳",
	},
	{
		countryNameEn: "British Indian Ocean Territories",
		countryNameLocal: "British Indian Ocean Territories",
		countryCode: "IO",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "246",
		areaCodes: [],
		region: "Indian Ocean",
		flag: "🇮🇴",
	},
	{
		countryNameEn: "Iraq",
		countryNameLocal: "العراق, Iraq",
		countryCode: "IQ",
		currencyCode: "IQD",
		currencyNameEn: "Iraqi dinar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "964",
		areaCodes: [],
		region: "Arab States",
		flag: "🇮🇶",
	},
	{
		countryNameEn: "Iran (Islamic Republic of)",
		countryNameLocal: "ایران",
		countryCode: "IR",
		currencyCode: "IRR",
		currencyNameEn: "Iranian rial",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fa",
		officialLanguageNameEn: "Persian",
		officialLanguageNameLocal: "فارسی",
		countryCallingCode: "98",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇮🇷",
	},
	{
		countryNameEn: "Iceland",
		countryNameLocal: "Ísland",
		countryCode: "IS",
		currencyCode: "ISK",
		currencyNameEn: "Icelandic króna",
		tinType: "VSK / VASK",
		tinName: "Virðisaukaskattsnúmer",
		officialLanguageCode: "is",
		officialLanguageNameEn: "Icelandic",
		officialLanguageNameLocal: "Íslenska",
		countryCallingCode: "354",
		areaCodes: [],
		region: "Europe",
		flag: "🇮🇸",
	},
	{
		countryNameEn: "Italy",
		countryNameLocal: "Italia",
		countryCode: "IT",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "P.IVA",
		tinName: "Partita IVA(IVA = Imposta sul Valore Aggiunto)",
		officialLanguageCode: "it",
		officialLanguageNameEn: "Italian",
		officialLanguageNameLocal: "Italiano",
		countryCallingCode: "39",
		areaCodes: [],
		region: "Europe",
		flag: "🇮🇹",
	},
	{
		countryNameEn: "Jersey",
		countryNameLocal: "Jersey",
		countryCode: "JE",
		currencyCode: "GBP",
		currencyNameEn: "Pound sterling",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "44",
		areaCodes: [],
		region: "Europe",
		flag: "🇯🇪",
	},
	{
		countryNameEn: "Jamaica",
		countryNameLocal: "Jamaica",
		countryCode: "JM",
		currencyCode: "JMD",
		currencyNameEn: "Jamaican dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "876",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇯🇲",
	},
	{
		countryNameEn: "Jordan",
		countryNameLocal: "الأُرْدُن",
		countryCode: "JO",
		currencyCode: "JOD",
		currencyNameEn: "Jordanian dinar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "962",
		areaCodes: [],
		region: "Arab States",
		flag: "🇯🇴",
	},
	{
		countryNameEn: "Japan",
		countryNameLocal: "日本",
		countryCode: "JP",
		currencyCode: "JPY",
		currencyNameEn: "Japanese yen",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ja",
		officialLanguageNameEn: "Japanese",
		officialLanguageNameLocal: "日本語 (にほんご)",
		countryCallingCode: "81",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇯🇵",
	},
	{
		countryNameEn: "Kenya",
		countryNameLocal: "Kenya",
		countryCode: "KE",
		currencyCode: "KES",
		currencyNameEn: "Kenyan shilling",
		tinType: "",
		tinName: "",
		officialLanguageCode: "sw",
		officialLanguageNameEn: "Swahili",
		officialLanguageNameLocal: "Kiswahili",
		countryCallingCode: "254",
		areaCodes: [],
		region: "Africa",
		flag: "🇰🇪",
	},
	{
		countryNameEn: "Kyrgyzstan",
		countryNameLocal: "Кыргызстан, Киргизия",
		countryCode: "KG",
		currencyCode: "KGS",
		currencyNameEn: "Kyrgyzstani som",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ky",
		officialLanguageNameEn: "Kirghiz, Kyrgyz",
		officialLanguageNameLocal: "Кыргызча, Кыргыз тили",
		countryCallingCode: "996",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇰🇬",
	},
	{
		countryNameEn: "Cambodia",
		countryNameLocal: "កម្ពុជា",
		countryCode: "KH",
		currencyCode: "KHR",
		currencyNameEn: "Cambodian riel",
		tinType: "",
		tinName: "",
		officialLanguageCode: "km",
		officialLanguageNameEn: "Central Khmer",
		officialLanguageNameLocal: "ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ",
		countryCallingCode: "855",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇰🇭",
	},
	{
		countryNameEn: "North Korea",
		countryNameLocal: "조선민주주의인민공화국",
		countryCode: "KP",
		currencyCode: "KPW",
		currencyNameEn: "North Korean won",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ko",
		officialLanguageNameEn: "Korean",
		officialLanguageNameLocal: "조선어",
		countryCallingCode: "850",
		areaCodes: [],
		region: "Asia",
		flag: "🇰🇵",
	},
	{
		countryNameEn: "South Korea",
		countryNameLocal: "대한민국",
		countryCode: "KR",
		currencyCode: "KRW",
		currencyNameEn: "South Korean won",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ko",
		officialLanguageNameEn: "Korean",
		officialLanguageNameLocal: "한국어",
		countryCallingCode: "82",
		areaCodes: [],
		region: "Asia",
		flag: "🇰🇷",
	},
	{
		countryNameEn: "Kiribati",
		countryNameLocal: "Kiribati",
		countryCode: "KI",
		currencyCode: "AUD",
		currencyNameEn: "Australian dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "686",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇰🇮",
	},
	{
		countryNameEn: "Saint Kitts and Nevis",
		countryNameLocal: "Saint Kitts and Nevis",
		countryCode: "KN",
		currencyCode: "XCD",
		currencyNameEn: "East Caribbean dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1869",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇰🇳",
	},
	{
		countryNameEn: "Kuwait",
		countryNameLocal: "الكويت",
		countryCode: "KW",
		currencyCode: "KWD",
		currencyNameEn: "Kuwaiti dinar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "965",
		areaCodes: [],
		region: "Arab States",
		flag: "🇰🇼",
	},
	{
		countryNameEn: "Kazakhstan",
		countryNameLocal: "Қазақстан, Казахстан",
		countryCode: "KZ",
		currencyCode: "KZT",
		currencyNameEn: "Kazakhstani tenge",
		tinType: "",
		tinName: "",
		officialLanguageCode: "kk",
		officialLanguageNameEn: "Kazakh",
		officialLanguageNameLocal: "қазақ тілі",
		countryCallingCode: "7",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇰🇿",
	},
	{
		countryNameEn: "Lebanon",
		countryNameLocal: "لبنان, Liban",
		countryCode: "LB",
		currencyCode: "LBP",
		currencyNameEn: "Lebanese pound",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "961",
		areaCodes: [],
		region: "Arab States",
		flag: "🇱🇧",
	},
	{
		countryNameEn: "Saint Lucia",
		countryNameLocal: "Saint Lucia",
		countryCode: "LC",
		currencyCode: "XCD",
		currencyNameEn: "East Caribbean dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1758",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇱🇨",
	},
	{
		countryNameEn: "Liechtenstein",
		countryNameLocal: "Liechtenstein",
		countryCode: "LI",
		currencyCode: "CHF",
		currencyNameEn: "Swiss franc",
		tinType: "",
		tinName: "",
		officialLanguageCode: "de",
		officialLanguageNameEn: "German",
		officialLanguageNameLocal: "Deutsch",
		countryCallingCode: "423",
		areaCodes: [],
		region: "Europe",
		flag: "🇱🇮",
	},
	{
		countryNameEn: "Sri Lanka",
		countryNameLocal: "ශ්‍රී ලංකා, இலங்கை",
		countryCode: "LK",
		currencyCode: "LKR",
		currencyNameEn: "Sri Lankan rupee",
		tinType: "",
		tinName: "",
		officialLanguageCode: "si",
		officialLanguageNameEn: "Sinhala, Sinhalese",
		officialLanguageNameLocal: "සිංහල",
		countryCallingCode: "94",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇱🇰",
	},
	{
		countryNameEn: "Liberia",
		countryNameLocal: "Liberia",
		countryCode: "LR",
		currencyCode: "LRD",
		currencyNameEn: "Liberian dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "231",
		areaCodes: [],
		region: "Africa",
		flag: "🇱🇷",
	},
	{
		countryNameEn: "Lesotho",
		countryNameLocal: "Lesotho",
		countryCode: "LS",
		currencyCode: "LSL",
		currencyNameEn: "Lesotho loti",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "266",
		areaCodes: [],
		region: "Africa",
		flag: "🇱🇸",
	},
	{
		countryNameEn: "Lithuania",
		countryNameLocal: "Lietuva",
		countryCode: "LT",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "PVM kodas",
		tinName: "PVM (abbrev. Pridėtinės vertės mokestis) mokėtojo kodas",
		officialLanguageCode: "lt",
		officialLanguageNameEn: "Lithuanian",
		officialLanguageNameLocal: "lietuvių kalba",
		countryCallingCode: "370",
		areaCodes: [],
		region: "Europe",
		flag: "🇱🇹",
	},
	{
		countryNameEn: "Luxembourg",
		countryNameLocal: "Lëtzebuerg, Luxembourg, Luxemburg",
		countryCode: "LU",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "No. TVA",
		tinName: "Numéro d'identification à la taxe sur la valeur ajoutée",
		officialLanguageCode: "lb",
		officialLanguageNameEn: "Luxembourgish, Letzeburgesch",
		officialLanguageNameLocal: "Lëtzebuergesch",
		countryCallingCode: "352",
		areaCodes: [],
		region: "Europe",
		flag: "🇱🇺",
	},
	{
		countryNameEn: "Latvia",
		countryNameLocal: "Latvija",
		countryCode: "LV",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "PVN",
		tinName: "Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs",
		officialLanguageCode: "lv",
		officialLanguageNameEn: "Latvian",
		officialLanguageNameLocal: "latviešu valoda",
		countryCallingCode: "371",
		areaCodes: [],
		region: "Europe",
		flag: "🇱🇻",
	},
	{
		countryNameEn: "Libya",
		countryNameLocal: "ليبيا",
		countryCode: "LY",
		currencyCode: "LYD",
		currencyNameEn: "Libyan dinar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "218",
		areaCodes: [],
		region: "Arab States",
		flag: "🇱🇾",
	},
	{
		countryNameEn: "Morocco",
		countryNameLocal: "Maroc, ⵍⵎⵖⵔⵉⴱ, المغرب",
		countryCode: "MA",
		currencyCode: "MAD",
		currencyNameEn: "Moroccan dirham",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "212",
		areaCodes: [],
		region: "Arab States",
		flag: "🇲🇦",
	},
	{
		countryNameEn: "Monaco",
		countryNameLocal: "Monaco",
		countryCode: "MC",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "377",
		areaCodes: [],
		region: "Europe",
		flag: "🇲🇨",
	},
	{
		countryNameEn: "Montenegro",
		countryNameLocal: "Crna Gora, Црна Гора",
		countryCode: "ME",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "srp",
		officialLanguageNameEn: "српски језик",
		officialLanguageNameLocal: "",
		countryCallingCode: "382",
		areaCodes: [],
		region: "Europe",
		flag: "🇲🇪",
	},
	{
		countryNameEn: "Saint Martin (French part)",
		countryNameLocal: "Saint-Martin",
		countryCode: "MF",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "590",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇲🇫",
	},
	{
		countryNameEn: "Madagascar",
		countryNameLocal: "Madagasikara, Madagascar",
		countryCode: "MG",
		currencyCode: "MGA",
		currencyNameEn: "Malagasy ariary",
		tinType: "",
		tinName: "",
		officialLanguageCode: "mg",
		officialLanguageNameEn: "Malagasy",
		officialLanguageNameLocal: "fiteny malagasy",
		countryCallingCode: "261",
		areaCodes: [],
		region: "Africa",
		flag: "🇲🇬",
	},
	{
		countryNameEn: "Mali",
		countryNameLocal: "Mali",
		countryCode: "ML",
		currencyCode: "XOF",
		currencyNameEn: "CFA franc BCEAO",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "223",
		areaCodes: [],
		region: "Africa",
		flag: "🇲🇱",
	},
	{
		countryNameEn: "Myanmar",
		countryNameLocal: "မြန်မာ",
		countryCode: "MM",
		currencyCode: "MMK",
		currencyNameEn: "Myanmar kyat",
		tinType: "",
		tinName: "",
		officialLanguageCode: "my",
		officialLanguageNameEn: "Burmese",
		officialLanguageNameLocal: "ဗမာစာ",
		countryCallingCode: "95",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇲🇲",
	},
	{
		countryNameEn: "Mongolia",
		countryNameLocal: "Монгол Улс",
		countryCode: "MN",
		currencyCode: "MNT",
		currencyNameEn: "Mongolian tögrög",
		tinType: "",
		tinName: "",
		officialLanguageCode: "mn",
		officialLanguageNameEn: "Mongolian",
		officialLanguageNameLocal: "Монгол хэл",
		countryCallingCode: "976",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇲🇳",
	},
	{
		countryNameEn: "Macao",
		countryNameLocal: "澳門, Macau",
		countryCode: "MO",
		currencyCode: "MOP",
		currencyNameEn: "Macanese pataca",
		tinType: "",
		tinName: "",
		officialLanguageCode: "zh-hant",
		officialLanguageNameEn: "",
		officialLanguageNameLocal: "",
		countryCallingCode: "853",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇲🇴",
	},
	{
		countryNameEn: "Martinique",
		countryNameLocal: "Martinique",
		countryCode: "MQ",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "596",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇲🇶",
	},
	{
		countryNameEn: "Mauritania",
		countryNameLocal: "موريتانيا, Mauritanie",
		countryCode: "MR",
		currencyCode: "MRU",
		currencyNameEn: "",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "222",
		areaCodes: [],
		region: "Arab States",
		flag: "🇲🇷",
	},
	{
		countryNameEn: "Montserrat",
		countryNameLocal: "Montserrat",
		countryCode: "MS",
		currencyCode: "XCD",
		currencyNameEn: "East Caribbean dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1664",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇲🇸",
	},
	{
		countryNameEn: "Malta",
		countryNameLocal: "Malta",
		countryCode: "MT",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "Vat No.",
		tinName: "Vat reg. no.",
		officialLanguageCode: "mt",
		officialLanguageNameEn: "Maltese",
		officialLanguageNameLocal: "Malti",
		countryCallingCode: "356",
		areaCodes: [],
		region: "Europe",
		flag: "🇲🇹",
	},
	{
		countryNameEn: "Mauritius",
		countryNameLocal: "Maurice, Mauritius",
		countryCode: "MU",
		currencyCode: "MUR",
		currencyNameEn: "Mauritian rupee",
		tinType: "",
		tinName: "",
		officialLanguageCode: "mfe",
		officialLanguageNameEn: "",
		officialLanguageNameLocal: "",
		countryCallingCode: "230",
		areaCodes: [],
		region: "Africa",
		flag: "🇲🇺",
	},
	{
		countryNameEn: "Maldives",
		countryNameLocal: "",
		countryCode: "MV",
		currencyCode: "MVR",
		currencyNameEn: "Maldivian rufiyaa",
		tinType: "",
		tinName: "",
		officialLanguageCode: "dv",
		officialLanguageNameEn: "Divehi, Dhivehi, Maldivian",
		officialLanguageNameLocal: "ދިވެހި",
		countryCallingCode: "960",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇲🇻",
	},
	{
		countryNameEn: "Malawi",
		countryNameLocal: "Malawi",
		countryCode: "MW",
		currencyCode: "MWK",
		currencyNameEn: "Malawian kwacha",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "265",
		areaCodes: [],
		region: "Africa",
		flag: "🇲🇼",
	},
	{
		countryNameEn: "Mexico",
		countryNameLocal: "México",
		countryCode: "MX",
		currencyCode: "MXN",
		currencyNameEn: "Mexican peso",
		tinType: "RFC",
		tinName: "Registro Federal de Contribuyentes",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "52",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇲🇽",
	},
	{
		countryNameEn: "Malaysia",
		countryNameLocal: "",
		countryCode: "MY",
		currencyCode: "MYR",
		currencyNameEn: "Malaysian ringgit",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ms",
		officialLanguageNameEn: "Malay",
		officialLanguageNameLocal: "Bahasa Melayu, بهاس ملايو‎",
		countryCallingCode: "60",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇲🇾",
	},
	{
		countryNameEn: "Mozambique",
		countryNameLocal: "Mozambique",
		countryCode: "MZ",
		currencyCode: "MZN",
		currencyNameEn: "Mozambican metical",
		tinType: "",
		tinName: "",
		officialLanguageCode: "pt",
		officialLanguageNameEn: "Portuguese",
		officialLanguageNameLocal: "Português",
		countryCallingCode: "258",
		areaCodes: [],
		region: "Africa",
		flag: "🇲🇿",
	},
	{
		countryNameEn: "Namibia",
		countryNameLocal: "Namibia",
		countryCode: "NA",
		currencyCode: "NAD",
		currencyNameEn: "Namibian dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "264",
		areaCodes: [],
		region: "Africa",
		flag: "🇳🇦",
	},
	{
		countryNameEn: "New Caledonia",
		countryNameLocal: "Nouvelle-Calédonie",
		countryCode: "NC",
		currencyCode: "XPF",
		currencyNameEn: "CFP franc (franc Pacifique)",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "687",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇳🇨",
	},
	{
		countryNameEn: "Norfolk Island",
		countryNameLocal: "Norfolk Island",
		countryCode: "NF",
		currencyCode: "AUD",
		currencyNameEn: "Australian dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "672",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇳🇫",
	},
	{
		countryNameEn: "Nigeria",
		countryNameLocal: "Nigeria",
		countryCode: "NG",
		currencyCode: "NGN",
		currencyNameEn: "Nigerian naira",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "234",
		areaCodes: [],
		region: "Africa",
		flag: "🇳🇬",
	},
	{
		countryNameEn: "Nicaragua",
		countryNameLocal: "Nicaragua",
		countryCode: "NI",
		currencyCode: "NIO",
		currencyNameEn: "Nicaraguan córdoba",
		tinType: "RUC",
		tinName: "Registro Unico de Contribuyentes",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "505",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇳🇮",
	},
	{
		countryNameEn: "Norway",
		countryNameLocal: "Norge, Noreg",
		countryCode: "NO",
		currencyCode: "NOK",
		currencyNameEn: "Norwegian krone",
		tinType: "Orgnr",
		tinName: "Organisasjonsnummer",
		officialLanguageCode: "nb",
		officialLanguageNameEn: "Norwegian Bokmål",
		officialLanguageNameLocal: "Norsk Bokmål",
		countryCallingCode: "47",
		areaCodes: [],
		region: "Europe",
		flag: "🇳🇴",
	},
	{
		countryNameEn: "Nepal",
		countryNameLocal: "",
		countryCode: "NP",
		currencyCode: "NPR",
		currencyNameEn: "Nepalese rupee",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ne",
		officialLanguageNameEn: "Nepali",
		officialLanguageNameLocal: "नेपाली",
		countryCallingCode: "977",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇳🇵",
	},
	{
		countryNameEn: "Nauru",
		countryNameLocal: "Nauru",
		countryCode: "NR",
		currencyCode: "AUD",
		currencyNameEn: "Australian dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "na",
		officialLanguageNameEn: "Nauru",
		officialLanguageNameLocal: "Dorerin Naoero",
		countryCallingCode: "674",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇳🇷",
	},
	{
		countryNameEn: "Niue",
		countryNameLocal: "Niue",
		countryCode: "NU",
		currencyCode: "NZD",
		currencyNameEn: "New Zealand dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "niu",
		officialLanguageNameEn: "",
		officialLanguageNameLocal: "",
		countryCallingCode: "683",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇳🇺",
	},
	{
		countryNameEn: "New Zealand",
		countryNameLocal: "New Zealand",
		countryCode: "NZ",
		currencyCode: "NZD",
		currencyNameEn: "New Zealand dollar",
		tinType: "NZBN",
		tinName: "NZ Business Number",
		officialLanguageCode: "mi",
		officialLanguageNameEn: "Maori",
		officialLanguageNameLocal: "te reo Māori",
		countryCallingCode: "64",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇳🇿",
	},
	{
		countryNameEn: "Oman",
		countryNameLocal: "سلطنة عُمان",
		countryCode: "OM",
		currencyCode: "OMR",
		currencyNameEn: "Omani rial",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "968",
		areaCodes: [],
		region: "Arab States",
		flag: "🇴🇲",
	},
	{
		countryNameEn: "Panama",
		countryNameLocal: "Panama",
		countryCode: "PA",
		currencyCode: "PAB",
		currencyNameEn: "Panamanian balboa",
		tinType: "RUC",
		tinName: "Registro Unico de Contribuyentes",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "507",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇵🇦",
	},
	{
		countryNameEn: "Peru",
		countryNameLocal: "Perú",
		countryCode: "PE",
		currencyCode: "PEN",
		currencyNameEn: "Peruvian sol",
		tinType: "RUC",
		tinName: "Registro Unico de Contribuyentes",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "51",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇵🇪",
	},
	{
		countryNameEn: "French Polynesia",
		countryNameLocal: "Polynésie française",
		countryCode: "PF",
		currencyCode: "XPF",
		currencyNameEn: "CFP franc (franc Pacifique)",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "689",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇵🇫",
	},
	{
		countryNameEn: "Papua New Guinea",
		countryNameLocal: "Papua New Guinea",
		countryCode: "PG",
		currencyCode: "PGK",
		currencyNameEn: "Papua New Guinean kina",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "675",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇵🇬",
	},
	{
		countryNameEn: "Pakistan",
		countryNameLocal: "پاکستان",
		countryCode: "PK",
		currencyCode: "PKR",
		currencyNameEn: "Pakistani rupee",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "92",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇵🇰",
	},
	{
		countryNameEn: "Poland",
		countryNameLocal: "Polska",
		countryCode: "PL",
		currencyCode: "PLN",
		currencyNameEn: "Polish złoty",
		tinType: "NIP",
		tinName: "numer identyfikacji podatkowej",
		officialLanguageCode: "pl",
		officialLanguageNameEn: "Polish",
		officialLanguageNameLocal: "język polski, polszczyzna",
		countryCallingCode: "48",
		areaCodes: [],
		region: "Europe",
		flag: "🇵🇱",
	},
	{
		countryNameEn: "Saint Pierre and Miquelon",
		countryNameLocal: "Saint-Pierre-et-Miquelon",
		countryCode: "PM",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "508",
		areaCodes: [],
		region: "North America",
		flag: "🇵🇲",
	},
	{
		countryNameEn: "Pitcairn",
		countryNameLocal: "Pitcairn",
		countryCode: "PN",
		currencyCode: "NZD",
		currencyNameEn: "New Zealand dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "64",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇵🇳",
	},
	{
		countryNameEn: "Puerto Rico",
		countryNameLocal: "Puerto Rico",
		countryCode: "PR",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "1",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇵🇷",
	},
	{
		countryNameEn: "Palestine, State of",
		countryNameLocal: "Palestinian Territory",
		countryCode: "PS",
		currencyCode: "",
		currencyNameEn: "",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "970",
		areaCodes: [],
		region: "Arab States",
		flag: "🇵🇸",
	},
	{
		countryNameEn: "Portugal",
		countryNameLocal: "Portugal",
		countryCode: "PT",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "NIPC",
		tinName: "Número de Identificação de Pessoa Coletiva (NIPC)",
		officialLanguageCode: "pt",
		officialLanguageNameEn: "Portuguese",
		officialLanguageNameLocal: "Português",
		countryCallingCode: "351",
		areaCodes: [],
		region: "Europe",
		flag: "🇵🇹",
	},
	{
		countryNameEn: "Palau",
		countryNameLocal: "Palau",
		countryCode: "PW",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "680",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇵🇼",
	},
	{
		countryNameEn: "Paraguay",
		countryNameLocal: "Paraguay",
		countryCode: "PY",
		currencyCode: "PYG",
		currencyNameEn: "Paraguayan guaraní",
		tinType: "RUC",
		tinName: "Registro Unico de Contribuyentes",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "595",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇵🇾",
	},
	{
		countryNameEn: "Qatar",
		countryNameLocal: "قطر",
		countryCode: "QA",
		currencyCode: "QAR",
		currencyNameEn: "Qatari riyal",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "974",
		areaCodes: [],
		region: "Arab States",
		flag: "🇶🇦",
	},
	{
		countryNameEn: "Réunion",
		countryNameLocal: "La Réunion",
		countryCode: "RE",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "262",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇷🇪",
	},
	{
		countryNameEn: "Romania",
		countryNameLocal: "România",
		countryCode: "RO",
		currencyCode: "RON",
		currencyNameEn: "Romanian leu",
		tinType: "CIF",
		tinName: "Codul de identificare fiscală",
		officialLanguageCode: "ro",
		officialLanguageNameEn: "Romanian, Moldavian, Moldovan",
		officialLanguageNameLocal: "Română",
		countryCallingCode: "40",
		areaCodes: [],
		region: "Europe",
		flag: "🇷🇴",
	},
	{
		countryNameEn: "Serbia",
		countryNameLocal: "Србија",
		countryCode: "RS",
		currencyCode: "RSD",
		currencyNameEn: "Serbian dinar",
		tinType: "PIB",
		tinName: "Poreski identifikacioni broj",
		officialLanguageCode: "sr",
		officialLanguageNameEn: "Serbian",
		officialLanguageNameLocal: "српски језик",
		countryCallingCode: "381",
		areaCodes: [],
		region: "Europe",
		flag: "🇷🇸",
	},
	{
		countryNameEn: "Russia",
		countryNameLocal: "Россия",
		countryCode: "RU",
		currencyCode: "RUB",
		currencyNameEn: "Russian ruble",
		tinType: "ИНН",
		tinName: "Идентификационный номер налогоплательщика",
		officialLanguageCode: "ru",
		officialLanguageNameEn: "Russian",
		officialLanguageNameLocal: "русский",
		countryCallingCode: "7",
		areaCodes: [],
		region: "Europe",
		flag: "🇷🇺",
	},
	{
		countryNameEn: "Rwanda",
		countryNameLocal: "Rwanda",
		countryCode: "RW",
		currencyCode: "RWF",
		currencyNameEn: "Rwandan franc",
		tinType: "",
		tinName: "",
		officialLanguageCode: "rw",
		officialLanguageNameEn: "Kinyarwanda",
		officialLanguageNameLocal: "Ikinyarwanda",
		countryCallingCode: "250",
		areaCodes: [],
		region: "Africa",
		flag: "🇷🇼",
	},
	{
		countryNameEn: "Saudi Arabia",
		countryNameLocal: "السعودية",
		countryCode: "SA",
		currencyCode: "SAR",
		currencyNameEn: "Saudi riyal",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "966",
		areaCodes: [],
		region: "Arab States",
		flag: "🇸🇦",
	},
	{
		countryNameEn: "Solomon Islands",
		countryNameLocal: "Solomon Islands",
		countryCode: "SB",
		currencyCode: "SBD",
		currencyNameEn: "Solomon Islands dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "677",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇸🇧",
	},
	{
		countryNameEn: "Seychelles",
		countryNameLocal: "Seychelles",
		countryCode: "SC",
		currencyCode: "SCR",
		currencyNameEn: "Seychelles rupee",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "248",
		areaCodes: [],
		region: "Africa",
		flag: "🇸🇨",
	},
	{
		countryNameEn: "Sweden",
		countryNameLocal: "Sverige",
		countryCode: "SE",
		currencyCode: "SEK",
		currencyNameEn: "Swedish krona/kronor",
		tinType: "Momsnr.",
		tinName: "VAT-nummer",
		officialLanguageCode: "sv",
		officialLanguageNameEn: "Swedish",
		officialLanguageNameLocal: "Svenska",
		countryCallingCode: "46",
		areaCodes: [],
		region: "Europe",
		flag: "🇸🇪",
	},
	{
		countryNameEn: "Singapore",
		countryNameLocal: "Singapore",
		countryCode: "SG",
		currencyCode: "SGD",
		currencyNameEn: "Singapore dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "zh-hans",
		officialLanguageNameEn: "",
		officialLanguageNameLocal: "",
		countryCallingCode: "65",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇸🇬",
	},
	{
		countryNameEn: "Saint Helena, Ascension and Tristan da Cunha",
		countryNameLocal: "Saint Helena",
		countryCode: "SH",
		currencyCode: "SHP",
		currencyNameEn: "Saint Helena pound",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "290",
		areaCodes: [],
		region: "Africa",
		flag: "🇸🇭",
	},
	{
		countryNameEn: "Slovenia",
		countryNameLocal: "Slovenija",
		countryCode: "SI",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "ID za DDV",
		tinName: "Davčna številka",
		officialLanguageCode: "sl",
		officialLanguageNameEn: "Slovenian",
		officialLanguageNameLocal: "Slovenski Jezik, Slovenščina",
		countryCallingCode: "386",
		areaCodes: [],
		region: "Europe",
		flag: "🇸🇮",
	},
	{
		countryNameEn: "Svalbard and Jan Mayen",
		countryNameLocal: "Svalbard and Jan Mayen",
		countryCode: "SJ",
		currencyCode: "NOK",
		currencyNameEn: "Norwegian krone",
		tinType: "",
		tinName: "",
		officialLanguageCode: "no",
		officialLanguageNameEn: "Norwegian",
		officialLanguageNameLocal: "Norsk",
		countryCallingCode: "4779",
		areaCodes: [],
		region: "Europe",
		flag: "🇸🇯",
	},
	{
		countryNameEn: "Slovakia",
		countryNameLocal: "Slovensko",
		countryCode: "SK",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "IČ DPH",
		tinName: "Identifikačné číslo pre daň z pridanej hodnoty",
		officialLanguageCode: "sk",
		officialLanguageNameEn: "Slovak",
		officialLanguageNameLocal: "Slovenčina, Slovenský Jazyk",
		countryCallingCode: "421",
		areaCodes: [],
		region: "Europe",
		flag: "🇸🇰",
	},
	{
		countryNameEn: "Sierra Leone",
		countryNameLocal: "Sierra Leone",
		countryCode: "SL",
		currencyCode: "SLL",
		currencyNameEn: "Sierra Leonean leone",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "232",
		areaCodes: [],
		region: "Africa",
		flag: "🇸🇱",
	},
	{
		countryNameEn: "Republic of San Marino",
		countryNameLocal: "Repubblica di San Marino",
		countryCode: "SM",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "C.O.E.",
		tinName: "Codice operatore economico",
		officialLanguageCode: "it",
		officialLanguageNameEn: "Italian",
		officialLanguageNameLocal: "Italiano",
		countryCallingCode: "378",
		areaCodes: [],
		region: "Europe",
		flag: "🇸🇲",
	},
	{
		countryNameEn: "Senegal",
		countryNameLocal: "Sénégal",
		countryCode: "SN",
		currencyCode: "XOF",
		currencyNameEn: "CFA franc BCEAO",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "221",
		areaCodes: [],
		region: "Africa",
		flag: "🇸🇳",
	},
	{
		countryNameEn: "Somalia",
		countryNameLocal: "Somalia, الصومال",
		countryCode: "SO",
		currencyCode: "SOS",
		currencyNameEn: "Somali shilling",
		tinType: "",
		tinName: "",
		officialLanguageCode: "so",
		officialLanguageNameEn: "Somali",
		officialLanguageNameLocal: "Soomaaliga, af Soomaali",
		countryCallingCode: "252",
		areaCodes: [],
		region: "Arab States",
		flag: "🇸🇴",
	},
	{
		countryNameEn: "Suriname",
		countryNameLocal: "Suriname",
		countryCode: "SR",
		currencyCode: "SRD",
		currencyNameEn: "Surinamese dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "nl",
		officialLanguageNameEn: "Dutch, Flemish",
		officialLanguageNameLocal: "Nederlands, Vlaams",
		countryCallingCode: "597",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇸🇷",
	},
	{
		countryNameEn: "South Sudan",
		countryNameLocal: "South Sudan",
		countryCode: "SS",
		currencyCode: "SSP",
		currencyNameEn: "South Sudanese pound",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "211",
		areaCodes: [],
		region: "Africa",
		flag: "🇸🇸",
	},
	{
		countryNameEn: "Sao Tome and Principe",
		countryNameLocal: "São Tomé e Príncipe",
		countryCode: "ST",
		currencyCode: "STN",
		currencyNameEn: "",
		tinType: "",
		tinName: "",
		officialLanguageCode: "pt",
		officialLanguageNameEn: "Portuguese",
		officialLanguageNameLocal: "Português",
		countryCallingCode: "239",
		areaCodes: [],
		region: "Africa",
		flag: "🇸🇹",
	},
	{
		countryNameEn: "El Salvador",
		countryNameLocal: "El Salvador",
		countryCode: "SV",
		currencyCode: "SVC",
		currencyNameEn: "Salvadoran colón",
		tinType: "NIT",
		tinName: "Número de Identificación Tributaria",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "503",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇸🇻",
	},
	{
		countryNameEn: "Sint Maarten (Dutch part)",
		countryNameLocal: "Sint Maarten",
		countryCode: "SX",
		currencyCode: "ANG",
		currencyNameEn: "Netherlands Antillean guilder",
		tinType: "",
		tinName: "",
		officialLanguageCode: "nl",
		officialLanguageNameEn: "Dutch, Flemish",
		officialLanguageNameLocal: "Nederlands, Vlaams",
		countryCallingCode: "1721",
		areaCodes: [],
		region: "Unknown",
		flag: "🇸🇽",
	},
	{
		countryNameEn: "Syrian Arab Republic",
		countryNameLocal: "سوريا, Sūriyya",
		countryCode: "SY",
		currencyCode: "SYP",
		currencyNameEn: "Syrian pound",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "963",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇸🇾",
	},
	{
		countryNameEn: "Chad",
		countryNameLocal: "Tchad, تشاد",
		countryCode: "TD",
		currencyCode: "XAF",
		currencyNameEn: "CFA franc BEAC",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "235",
		areaCodes: [],
		region: "Africa",
		flag: "🇹🇩",
	},
	{
		countryNameEn: "Togo",
		countryNameLocal: "Togo",
		countryCode: "TG",
		currencyCode: "XOF",
		currencyNameEn: "CFA franc BCEAO",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "228",
		areaCodes: [],
		region: "Africa",
		flag: "🇹🇬",
	},
	{
		countryNameEn: "Thailand",
		countryNameLocal: "ประเทศไทย",
		countryCode: "TH",
		currencyCode: "THB",
		currencyNameEn: "Thai baht",
		tinType: "",
		tinName: "",
		officialLanguageCode: "th",
		officialLanguageNameEn: "Thai",
		officialLanguageNameLocal: "ไทย",
		countryCallingCode: "66",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇹🇭",
	},
	{
		countryNameEn: "Tajikistan",
		countryNameLocal: ",",
		countryCode: "TJ",
		currencyCode: "TJS",
		currencyNameEn: "Tajikistani somoni",
		tinType: "",
		tinName: "",
		officialLanguageCode: "tg",
		officialLanguageNameEn: "Tajik",
		officialLanguageNameLocal: "тоҷикӣ, toçikī, تاجیکی‎",
		countryCallingCode: "992",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇹🇯",
	},
	{
		countryNameEn: "Tokelau",
		countryNameLocal: "Tokelau",
		countryCode: "TK",
		currencyCode: "NZD",
		currencyNameEn: "New Zealand dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "tkl",
		officialLanguageNameEn: "",
		officialLanguageNameLocal: "",
		countryCallingCode: "690",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇹🇰",
	},
	{
		countryNameEn: "Timor-Leste",
		countryNameLocal: "Timor-Leste, Timor Lorosa'e",
		countryCode: "TL",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "pt",
		officialLanguageNameEn: "Portuguese",
		officialLanguageNameLocal: "Português",
		countryCallingCode: "670",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇹🇱",
	},
	{
		countryNameEn: "Turkmenistan",
		countryNameLocal: "Türkmenistan",
		countryCode: "TM",
		currencyCode: "TMT",
		currencyNameEn: "Turkmenistan manat",
		tinType: "",
		tinName: "",
		officialLanguageCode: "tk",
		officialLanguageNameEn: "Turkmen",
		officialLanguageNameLocal: "Türkmen, Түркмен",
		countryCallingCode: "993",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇹🇲",
	},
	{
		countryNameEn: "Tunisia",
		countryNameLocal: "تونس, Tunisie",
		countryCode: "TN",
		currencyCode: "TND",
		currencyNameEn: "Tunisian dinar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "216",
		areaCodes: [],
		region: "Arab States",
		flag: "🇹🇳",
	},
	{
		countryNameEn: "Tonga",
		countryNameLocal: "Tonga",
		countryCode: "TO",
		currencyCode: "TOP",
		currencyNameEn: "Tongan paʻanga",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "676",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇹🇴",
	},
	{
		countryNameEn: "Turkey",
		countryNameLocal: "Türkiye",
		countryCode: "TR",
		currencyCode: "TRY",
		currencyNameEn: "Turkish lira",
		tinType: "KDV",
		tinName: "Vergi Kimlik Numarası",
		officialLanguageCode: "tr",
		officialLanguageNameEn: "Turkish",
		officialLanguageNameLocal: "Türkçe",
		countryCallingCode: "90",
		areaCodes: [],
		region: "Europe",
		flag: "🇹🇷",
	},
	{
		countryNameEn: "Trinidad and Tobago",
		countryNameLocal: "Trinidad and Tobago",
		countryCode: "TT",
		currencyCode: "TTD",
		currencyNameEn: "Trinidad and Tobago dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "868",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇹🇹",
	},
	{
		countryNameEn: "Tuvalu",
		countryNameLocal: "Tuvalu",
		countryCode: "TV",
		currencyCode: "AUD",
		currencyNameEn: "Australian dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "688",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇹🇻",
	},
	{
		countryNameEn: "United Republic of Tanzania",
		countryNameLocal: "Tanzania",
		countryCode: "TZ",
		currencyCode: "TZS",
		currencyNameEn: "Tanzanian shilling",
		tinType: "",
		tinName: "",
		officialLanguageCode: "sw",
		officialLanguageNameEn: "Swahili",
		officialLanguageNameLocal: "Kiswahili",
		countryCallingCode: "255",
		areaCodes: [],
		region: "Africa",
		flag: "🇹🇿",
	},
	{
		countryNameEn: "Ukraine",
		countryNameLocal: "Україна",
		countryCode: "UA",
		currencyCode: "UAH",
		currencyNameEn: "Ukrainian hryvnia",
		tinType: "ІНПП",
		tinName: "Ідентифікаційний номер платника податків",
		officialLanguageCode: "uk",
		officialLanguageNameEn: "Ukrainian",
		officialLanguageNameLocal: "Українська",
		countryCallingCode: "380",
		areaCodes: [],
		region: "Europe",
		flag: "🇺🇦",
	},
	{
		countryNameEn: "Uganda",
		countryNameLocal: "Uganda",
		countryCode: "UG",
		currencyCode: "UGX",
		currencyNameEn: "Ugandan shilling",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "256",
		areaCodes: [],
		region: "Africa",
		flag: "🇺🇬",
	},
	{
		countryNameEn: "United States of America",
		countryNameLocal: "United States of America",
		countryCode: "US",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "EIN",
		tinName: "Tax Identification Number",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1",
		areaCodes: [],
		region: "North America",
		flag: "🇺🇸",
	},
	{
		countryNameEn: "Uruguay",
		countryNameLocal: "Uruguay",
		countryCode: "UY",
		currencyCode: "UYU",
		currencyNameEn: "Uruguayan peso",
		tinType: "RUT",
		tinName: "Registro Único Tributario",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "598",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇺🇾",
	},
	{
		countryNameEn: "Uzbekistan",
		countryNameLocal: "",
		countryCode: "UZ",
		currencyCode: "UZS",
		currencyNameEn: "Uzbekistan som",
		tinType: "СТИР",
		tinName: "Солиқ тўловчиларнинг идентификация рақами",
		officialLanguageCode: "uz",
		officialLanguageNameEn: "Uzbek",
		officialLanguageNameLocal: "Oʻzbek, Ўзбек, أۇزبېك‎",
		countryCallingCode: "998",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇺🇿",
	},
	{
		countryNameEn: "Saint Vincent and the Grenadines",
		countryNameLocal: "Saint Vincent and the Grenadines",
		countryCode: "VC",
		currencyCode: "XCD",
		currencyNameEn: "East Caribbean dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1784",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇻🇨",
	},
	{
		countryNameEn: "Venezuela (Bolivarian Republic of)",
		countryNameLocal: "Venezuela",
		countryCode: "VE",
		currencyCode: "VES",
		currencyNameEn: "",
		tinType: "RIF",
		tinName: "Registro de Informacion Fiscal",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "58",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇻🇪",
	},
	{
		countryNameEn: "Virgin Islands (British)",
		countryNameLocal: "British Virgin Islands",
		countryCode: "VG",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1284",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇻🇬",
	},
	{
		countryNameEn: "Virgin Islands (U.S.)",
		countryNameLocal: "United States Virgin Islands",
		countryCode: "VI",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1340",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇻🇮",
	},
	{
		countryNameEn: "Vietnam",
		countryNameLocal: "Việt Nam",
		countryCode: "VN",
		currencyCode: "VND",
		currencyNameEn: "Vietnamese đồng",
		tinType: "",
		tinName: "",
		officialLanguageCode: "vi",
		officialLanguageNameEn: "Vietnamese",
		officialLanguageNameLocal: "Tiếng Việt",
		countryCallingCode: "84",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇻🇳",
	},
	{
		countryNameEn: "Vanuatu",
		countryNameLocal: "Vanuatu",
		countryCode: "VU",
		currencyCode: "VUV",
		currencyNameEn: "Vanuatu vatu",
		tinType: "",
		tinName: "",
		officialLanguageCode: "bi",
		officialLanguageNameEn: "Bislama",
		officialLanguageNameLocal: "Bislama",
		countryCallingCode: "678",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇻🇺",
	},
	{
		countryNameEn: "Wallis and Futuna",
		countryNameLocal: "Wallis-et-Futuna",
		countryCode: "WF",
		currencyCode: "XPF",
		currencyNameEn: "CFP franc (franc Pacifique)",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "681",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇼🇫",
	},
	{
		countryNameEn: "Samoa",
		countryNameLocal: "Samoa",
		countryCode: "WS",
		currencyCode: "WST",
		currencyNameEn: "Samoan tala",
		tinType: "",
		tinName: "",
		officialLanguageCode: "sm",
		officialLanguageNameEn: "Samoan",
		officialLanguageNameLocal: "gagana fa'a Samoa",
		countryCallingCode: "685",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇼🇸",
	},
	{
		countryNameEn: "Yemen",
		countryNameLocal: "اليَمَن",
		countryCode: "YE",
		currencyCode: "YER",
		currencyNameEn: "Yemeni rial",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "967",
		areaCodes: [],
		region: "Arab States",
		flag: "🇾🇪",
	},
	{
		countryNameEn: "Mayotte",
		countryNameLocal: "Mayotte",
		countryCode: "YT",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "262",
		areaCodes: [],
		region: "Africa",
		flag: "🇾🇹",
	},
	{
		countryNameEn: "South Africa",
		countryNameLocal: "South Africa",
		countryCode: "ZA",
		currencyCode: "ZAR",
		currencyNameEn: "South African rand",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "27",
		areaCodes: [],
		region: "Africa",
		flag: "🇿🇦",
	},
	{
		countryNameEn: "Zambia",
		countryNameLocal: "Zambia",
		countryCode: "ZM",
		currencyCode: "ZMW",
		currencyNameEn: "Zambian kwacha",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "260",
		areaCodes: [],
		region: "Africa",
		flag: "🇿🇲",
	},
	{
		countryNameEn: "Zimbabwe",
		countryNameLocal: "Zimbabwe",
		countryCode: "ZW",
		currencyCode: "ZWL",
		currencyNameEn: "Zimbabwean dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "263",
		areaCodes: [],
		region: "Africa",
		flag: "🇿🇼",
	},
	{
		countryNameEn: "Eswatini",
		countryNameLocal: "Swaziland",
		countryCode: "SZ",
		currencyCode: "SZL",
		currencyNameEn: "Swazi lilangeni",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "268",
		areaCodes: [],
		region: "Africa",
		flag: "🇸🇿",
	},
	{
		countryNameEn: "North Macedonia",
		countryNameLocal: "Македонија",
		countryCode: "MK",
		currencyCode: "MKD",
		currencyNameEn: "Macedonian denar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "mk",
		officialLanguageNameEn: "Macedonian",
		officialLanguageNameLocal: "македонски јазик",
		countryCallingCode: "389",
		areaCodes: [],
		region: "Europe",
		flag: "🇲🇰",
	},
	{
		countryNameEn: "Philippines",
		countryNameLocal: "Philippines",
		countryCode: "PH",
		currencyCode: "PHP",
		currencyNameEn: "Philippine peso",
		tinType: "TIN",
		tinName: "Tax Identification Number",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "63",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇵🇭",
	},
	{
		countryNameEn: "Netherlands",
		countryNameLocal: "Nederland",
		countryCode: "NL",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "Btw-nr.",
		tinName: "Btw-nummer",
		officialLanguageCode: "nl",
		officialLanguageNameEn: "Dutch, Flemish",
		officialLanguageNameLocal: "Nederlands, Vlaams",
		countryCallingCode: "31",
		areaCodes: [],
		region: "Europe",
		flag: "🇳🇱",
	},
	{
		countryNameEn: "United Arab Emirates",
		countryNameLocal: "دولة الإمارات العربيّة المتّحدة",
		countryCode: "AE",
		currencyCode: "AED",
		currencyNameEn: "United Arab Emirates dirham",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "971",
		areaCodes: [],
		region: "Arab States",
		flag: "🇦🇪",
	},
	{
		countryNameEn: "Republic of Moldova",
		countryNameLocal: "Moldova, Молдавия",
		countryCode: "MD",
		currencyCode: "MDL",
		currencyNameEn: "Moldovan leu",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ro",
		officialLanguageNameEn: "Romanian, Moldavian, Moldovan",
		officialLanguageNameLocal: "Română",
		countryCallingCode: "373",
		areaCodes: [],
		region: "Europe",
		flag: "🇲🇩",
	},
	{
		countryNameEn: "Gambia",
		countryNameLocal: "The Gambia",
		countryCode: "GM",
		currencyCode: "GMD",
		currencyNameEn: "Gambian dalasi",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "220",
		areaCodes: [],
		region: "Africa",
		flag: "🇬🇲",
	},
	{
		countryNameEn: "Dominican Republic",
		countryNameLocal: "República Dominicana",
		countryCode: "DO",
		currencyCode: "DOP",
		currencyNameEn: "Dominican peso",
		tinType: "RNC",
		tinName: "Registro Nacional del Contribuyente",
		officialLanguageCode: "es",
		officialLanguageNameEn: "Spanish, Castilian",
		officialLanguageNameLocal: "Español",
		countryCallingCode: "1",
		areaCodes: [],
		region: "South/Latin America",
		flag: "🇩🇴",
	},
	{
		countryNameEn: "Sudan",
		countryNameLocal: "السودان",
		countryCode: "SD",
		currencyCode: "SDG",
		currencyNameEn: "Sudanese pound",
		tinType: "",
		tinName: "",
		officialLanguageCode: "ar",
		officialLanguageNameEn: "Arabic",
		officialLanguageNameLocal: "العربية",
		countryCallingCode: "249",
		areaCodes: [],
		region: "Arab States",
		flag: "🇸🇩",
	},
	{
		countryNameEn: "Lao People's Democratic Republic",
		countryNameLocal: "ປະຊາຊົນລາວ",
		countryCode: "LA",
		currencyCode: "LAK",
		currencyNameEn: "Lao kip",
		tinType: "",
		tinName: "",
		officialLanguageCode: "lo",
		officialLanguageNameEn: "Lao",
		officialLanguageNameLocal: "ພາສາລາວ",
		countryCallingCode: "856",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇱🇦",
	},
	{
		countryNameEn: "Taiwan, Province of China",
		countryNameLocal: "Taiwan",
		countryCode: "TW",
		currencyCode: "TWD",
		currencyNameEn: "New Taiwan dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "zh-hant",
		officialLanguageNameEn: "",
		officialLanguageNameLocal: "",
		countryCallingCode: "886",
		areaCodes: [],
		region: "Asia & Pacific",
		flag: "🇹🇼",
	},
	{
		countryNameEn: "Republic of the Congo",
		countryNameLocal: "République du Congo",
		countryCode: "CG",
		currencyCode: "XAF",
		currencyNameEn: "CFA franc BEAC",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "242",
		areaCodes: [],
		region: "Africa",
		flag: "🇨🇬",
	},
	{
		countryNameEn: "Czechia",
		countryNameLocal: "Česká republika",
		countryCode: "CZ",
		currencyCode: "CZK",
		currencyNameEn: "Czech koruna",
		tinType: "DIČ",
		tinName: "Daňové identifikační číslo",
		officialLanguageCode: "cs",
		officialLanguageNameEn: "Czech",
		officialLanguageNameLocal: "Čeština",
		countryCallingCode: "420",
		areaCodes: [],
		region: "Europe",
		flag: "🇨🇿",
	},
	{
		countryNameEn: "United Kingdom",
		countryNameLocal: "Great Britain",
		countryCode: "GB",
		currencyCode: "GBP",
		currencyNameEn: "Pound sterling",
		tinType: "VAT Reg No",
		tinName: "Value added tax registration number",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "44",
		areaCodes: [],
		region: "Europe",
		flag: "🇬🇧",
	},
	{
		countryNameEn: "Niger",
		countryNameLocal: "Niger",
		countryCode: "NE",
		currencyCode: "XOF",
		currencyNameEn: "CFA franc BCEAO",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "227",
		areaCodes: [],
		region: "Africa",
		flag: "🇳🇪",
	},
	{
		countryNameEn: "Democratic Republic of the Congo",
		countryNameLocal: "Democratic Republic of the Congo",
		countryCode: "CD",
		currencyCode: "CDF",
		currencyNameEn: "Congolese franc",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "243",
		areaCodes: [],
		region: "Africa",
		flag: "🇨🇩",
	},
	{
		countryNameEn: "Commonwealth of The Bahamas",
		countryNameLocal: "Commonwealth of The Bahamas",
		countryCode: "BS",
		currencyCode: "BSD",
		currencyNameEn: "Bahamian dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1 242",
		areaCodes: [],
		region: "Caribbean",
		flag: "🇧🇸",
	},
	{
		countryNameEn: "Cocos (Keeling) Islands",
		countryNameLocal: "Pulu Kokos (Keeling)",
		countryCode: "CC",
		currencyCode: "AUD",
		currencyNameEn: "Australian dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "61 891",
		areaCodes: [],
		region: "Australia",
		flag: "🇨🇨",
	},
	{
		countryNameEn: "Central African Republic",
		countryNameLocal: "République centrafricaine",
		countryCode: "CF",
		currencyCode: "XAF",
		currencyNameEn: "Central African CFA",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "236",
		areaCodes: [],
		region: "Africa",
		flag: "🇨🇫",
	},
	{
		countryNameEn: "Cook Islands",
		countryNameLocal: "Kūki 'Āirani",
		countryCode: "CK",
		currencyCode: "NZD",
		currencyNameEn: "New Zealand dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "682",
		areaCodes: [],
		region: "South Pacific Ocean",
		flag: "🇨🇰",
	},
	{
		countryNameEn: "Falkland Islands",
		countryNameLocal: "Falkland Islands",
		countryCode: "FK",
		currencyCode: "FKP",
		currencyNameEn: "Falklands pound",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "500",
		areaCodes: [],
		region: "South Atlantic Ocean",
		flag: "🇫🇰",
	},
	{
		countryNameEn: "Faroe Islands",
		countryNameLocal: "Færøerne",
		countryCode: "FO",
		currencyCode: "DKK",
		currencyNameEn: "Faroese króna",
		tinType: "",
		tinName: "",
		officialLanguageCode: "da",
		officialLanguageNameEn: "Danish",
		officialLanguageNameLocal: "dansk",
		countryCallingCode: "298",
		areaCodes: [],
		region: "Europe",
		flag: "🇫🇴",
	},
	{
		countryNameEn: "Territory of Heard Island and McDonald Islands",
		countryNameLocal: "Territory of Heard Island and McDonald Islands",
		countryCode: "HM",
		currencyCode: "AUD",
		currencyNameEn: "Australian dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "672",
		areaCodes: [],
		region: "Indian Ocean",
		flag: "🇭🇲",
	},
	{
		countryNameEn: "British Indian Ocean Territory",
		countryNameLocal: "British Indian Ocean Territory",
		countryCode: "IO",
		currencyCode: "USD",
		currencyNameEn: "United States Dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "246",
		areaCodes: [],
		region: "Indian Ocean",
		flag: "🇮🇴",
	},
	{
		countryNameEn: "Comoros",
		countryNameLocal: "Umoja wa Komori",
		countryCode: "KM",
		currencyCode: "KMF",
		currencyNameEn: "Comorian franc",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "269",
		areaCodes: [],
		region: "Indian Ocean",
		flag: "🇰🇲",
	},
	{
		countryNameEn: "Cayman Islands",
		countryNameLocal: "Cayman Islands",
		countryCode: "KY",
		currencyCode: "KYD",
		currencyNameEn: "Cayman Islands dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1 345",
		areaCodes: [],
		region: "Caribbean Sea",
		flag: "🇰🇾",
	},
	{
		countryNameEn: "Republic of the Marshall Islands",
		countryNameLocal: "Aolepān Aorōkin Ṃajeḷ",
		countryCode: "MH",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "692",
		areaCodes: [],
		region: "Pacific Ocean",
		flag: "🇲🇭",
	},
	{
		countryNameEn: "Commonwealth of the Northern Mariana Islands",
		countryNameLocal: "Sankattan Siha Na Islas Mariånas",
		countryCode: "MP",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1 670",
		areaCodes: [],
		region: "Pacific Ocean",
		flag: "🇲🇵",
	},
	{
		countryNameEn: "Turks and Caicos Islands",
		countryNameLocal: "Turks and Caicos Islands",
		countryCode: "TC",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1 649",
		areaCodes: [],
		region: "Atlantic Ocean",
		flag: "🇹🇨",
	},
	{
		countryNameEn: "French Southern and Antarctic Lands",
		countryNameLocal: "Terres australes et antarctiques françaises",
		countryCode: "TF",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "fr",
		officialLanguageNameEn: "French",
		officialLanguageNameLocal: "Français",
		countryCallingCode: "672",
		areaCodes: [],
		region: "Indian Ocean",
		flag: "🇹🇫",
	},
	{
		countryNameEn: "United States Minor Outlying Islands",
		countryNameLocal: "United States Minor Outlying Islands",
		countryCode: "UM",
		currencyCode: "USD",
		currencyNameEn: "United States dollar",
		tinType: "",
		tinName: "",
		officialLanguageCode: "en",
		officialLanguageNameEn: "English",
		officialLanguageNameLocal: "English",
		countryCallingCode: "1",
		areaCodes: [],
		region: "Pacific Ocean",
		flag: "🇺🇲",
	},
	{
		countryNameEn: "Holy See",
		countryNameLocal: "Sancta Sedes",
		countryCode: "VA",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "la",
		officialLanguageNameEn: "Latin",
		officialLanguageNameLocal: "lingua latīna",
		countryCallingCode: "39",
		areaCodes: [],
		region: "Europe",
		flag: "🇻🇦",
	},
	{
		countryNameEn: "Republic of Kosovo",
		countryNameLocal: "Republika e Kosovës",
		countryCode: "XK",
		currencyCode: "EUR",
		currencyNameEn: "Euro",
		tinType: "",
		tinName: "",
		officialLanguageCode: "sq",
		officialLanguageNameEn: "Albanian",
		officialLanguageNameLocal: "Shqip",
		countryCallingCode: "383",
		region: "Europe",
		flag: "🇽🇰",
	},
	{
		countryNameEn: "Netherlands Antilles",
		countryNameLocal: "Nederlandse Antillen",
		countryCode: "AN",
		currencyCode: "ANG",
		currencyNameEn: "Netherlands Antillean guilder",
		tinType: "",
		tinName: "",
		officialLanguageCode: "nl",
		officialLanguageNameEn: "Dutch, Flemish",
		officialLanguageNameLocal: "Nederlands, Vlaams",
		countryCallingCode: "599",
		region: "Europe",
		flag: "🇧🇶",
	},
];

var contactFormInit;

(function ($) {

	const selectors = {
		wrap: '[data-contact-form]',
		codeDropdown: '.js-code-dropdown',
	};

	contactFormInit = function () {
		$(selectors.wrap).each((i, el) => {
			new ContactForm(el);
		});
	};

	class ContactForm {
		constructor(element) {
			this.$wrap = $(element);

			this.init();
			this.bind();

			this.initChoices();

		}
		init() {
			this.$codeDropdown = $(selectors.codeDropdown, this.$wrap);
			this.$codeDropdown.html('');
		}

		bind() {
		}
		initChoices() {
			if (!this.$codeDropdown.length) return;

			// Get current language from HTML lang attribute
			const htmlLang = document.documentElement.lang || 'en-GB';
			let currentCountryCode = 'GB'; // Default to GB

			// Split the lang attribute and get country code
			const langParts = htmlLang.split('-');
			if (langParts.length > 1 && langParts[1]) {
				currentCountryCode = langParts[1].toUpperCase();
			} else {
				// Try underscore format (e.g., en_GB)
				const underscoreParts = htmlLang.split('_');
				if (underscoreParts.length > 1 && underscoreParts[1]) {
					currentCountryCode = underscoreParts[1].toUpperCase();
				}
			}

			// Create choices array from countriesData
			const choicesArray = countriesData.map(country => ({
				value: `+${country.countryCallingCode}`,
				label: country.countryCode,
				customProperties: {
					code: country.countryCode.toLowerCase(),
					fullName: country.countryNameEn
				}
			}));

			// Find the country that matches the current language
			let currentCountryIndex = -1;
			for (let i = 0; i < choicesArray.length; i++) {
				if (choicesArray[i].label === currentCountryCode ||
					choicesArray[i].customProperties.code.toUpperCase() === currentCountryCode) {
					currentCountryIndex = i;
					break;
				}
			}

			// If found, move it to the beginning of the array
			if (currentCountryIndex > -1) {
				const currentCountry = choicesArray[currentCountryIndex];
				choicesArray.splice(currentCountryIndex, 1);
				choicesArray.unshift(currentCountry);
			}

			this.choices = new Choices(this.$codeDropdown[0], {
				choices: choicesArray,
				searchEnabled: true,
				itemSelectText: '',
				searchFields: ['label', 'value', 'customProperties.fullName'],
				callbackOnCreateTemplates: function (strToEl, escapeForTemplate, getClassNames) {
					return {
						item: function (args, data) {
							// Get the original template
							const original = Choices.defaults.templates.item.call(this, args, data);

							// Create new element with flag
							const element = strToEl(`
            <div>
              <span class="fi fi-${data.customProperties.code}"></span>
              ${data.value}
            </div>
          `);

							// Replace the original content
							original.innerHTML = '';
							original.appendChild(element);

							return original;
						},
						choice: function (args, data) {
							// Get the original template
							const original = Choices.defaults.templates.choice.call(this, args, data);

							// Create new element with flag and hidden full name
							const element = strToEl(`
            <div class="country-choice-wrapper">
              <span class="fi fi-${data.customProperties.code}"></span>
              <span class="country-name">${data.label}</span>
              <span class="country-code">${data.value}</span>
            </div>
          `);

							// Replace the original content
							original.innerHTML = '';
							original.appendChild(element);

							return original;
						}
					};
				}
			});

		}

	}

})(jQuery);


var contactFormInit$1 = contactFormInit;

var configuratorInit;

(function ($) {

	const selectors = {
		wrap: '[data-configurator]',
		rangeSlider: '[data-configurator-range]',
		summaryImage: '[data-summary-image]',
		summaryLayersContainer: '[data-summary-layers-container]'
	};

	configuratorInit = function () {
		$(selectors.wrap).each((i, el) => {
			new Configurator(el);
		});
	};

	class Configurator {

		constructor(element) {
			this.$wrap = $(element);

			// Add tracking for form values and comments
			this.formValues = {};
			this.formComments = {};
			this.stepNames = {};

			// Add tracking for image layers
			this.colorQuestion = null;
			this.selectedColor = null;
			this.layerElements = {};

			this.init();
			this.bind();

			this.loadStepNames();
			this.initStepGroups();
			this.initSummarySection();
			this.initNoUiSlider();
			this.initImageLayers();
		}

		init() {
			this.$sliders = $(selectors.rangeSlider, this.$wrap);
			this.$summaryImage = $(selectors.summaryImage, this.$wrap);
			this.$summaryLayersContainer = $(selectors.summaryLayersContainer, this.$wrap);
		}

		bind() {
		}

		loadStepNames() {
			// Load all step names from hidden inputs
			$('input[data-step-name]', this.$wrap).each((i, el) => {
				const $input = $(el);
				const stepIdx = $input.data('step-idx');
				const stepName = $input.data('step-name');
				const groupWithPrev = $input.data('group-with-prev');
				this.stepNames[stepIdx] = {
					name: stepName,
					groupWithPrev: groupWithPrev
				};
			});
		}

		initSummarySection() {
			// Find summary containers
			this.$optionsSummary = $('[data-configurator-options]', this.$wrap);
			this.$commentsSummary = $('[data-configurator-comments]', this.$wrap);

			if (!this.$optionsSummary.length && !this.$commentsSummary.length) return;

			// Setup event listeners for all form elements
			this.setupFormTracking();
		}

		setupFormTracking() {
			// Track range sliders which already have their own setup
			this.$sliders.each((i, slider) => {
				const $slider = $(slider);
				this.setupRangeTracking($slider);
			});

			// Track checkboxes using data-field-type attribute
			$('input[data-field-type="checkbox"]', this.$wrap).each((i, el) => {
				this.setupCheckboxTracking($(el));
			});

			// Track comments (textareas) using data-field-type attribute
			$('[data-field-type="comment"]', this.$wrap).each((i, el) => {
				this.setupCommentTracking($(el));
			});

			// Handle multi-choice fields (radio buttons with photos)
			this.setupMultiChoiceTracking();
		}

		setupRangeTracking($slider) {
			const sliderId = $slider.attr('id');
			const inputField = document.getElementById(`${sliderId}-input`);
			const fieldLabel = $slider.data('field-label');

			$(inputField).on('change', () => {
				this.updateFormValue(inputField.name, inputField.value, fieldLabel, 'range', { suffix: $slider.data('suffix') });
			});
		}

		setupCheckboxTracking($checkbox) {
			const name = $checkbox.attr('name');
			const fieldLabel = $checkbox.data('field-label') || '';

			$checkbox.on('change', () => {
				const isChecked = $checkbox.prop('checked');

				if (isChecked) {
					this.updateFormValue(name, true, fieldLabel, 'checkbox');
				} else {
					this.removeFormValue(name);
				}
			});
		}

		setupCommentTracking($textarea) {
			const name = $textarea.attr('name');

			$textarea.on('change input', () => {
				const value = $textarea.val();

				if (value) {
					this.updateFormComment(name, value);
				} else {
					this.removeFormComment(name);
				}
			});
		}

		updateFormValue(name, value, label, type, data) {
			// Extract step index from field name
			const stepMatch = name.match(/step\[(\d+)\]/);
			if (!stepMatch) return;

			const stepIdx = stepMatch[1];

			if (!this.formValues[stepIdx]) {
				this.formValues[stepIdx] = {};
			}

			this.formValues[stepIdx][name] = {
				value: value,
				label: label || name,
				type: type,
				data: data
			};

			this.renderSummary();

			// Update the summary image layers when form values change
			if (this.$summaryLayersContainer.length > 0) {
				this.updateSummaryLayers();
			}
		}

		// Override the existing removeFormValue method to also update layers
		removeFormValue(name) {
			const stepMatch = name.match(/step\[(\d+)\]/);
			if (!stepMatch) return;

			const stepIdx = stepMatch[1];

			if (this.formValues[stepIdx] && this.formValues[stepIdx][name]) {
				delete this.formValues[stepIdx][name];
				this.renderSummary();

				// Update the summary image layers when form values change
				if (this.$summaryLayersContainer.length > 0) {
					this.updateSummaryLayers();
				}
			}
		}

		updateFormComment(name, value) {
			const stepMatch = name.match(/step\[(\d+)\]/);
			if (!stepMatch) return;

			const stepIdx = stepMatch[1];

			if (!this.formComments[stepIdx]) {
				this.formComments[stepIdx] = {};
			}

			this.formComments[stepIdx][name] = value;
			this.renderSummary();
		}

		removeFormComment(name) {
			const stepMatch = name.match(/step\[(\d+)\]/);
			if (!stepMatch) return;

			const stepIdx = stepMatch[1];

			if (this.formComments[stepIdx] && this.formComments[stepIdx][name]) {
				delete this.formComments[stepIdx][name];
				this.renderSummary();
			}
		}

		renderSummary() {
			this.renderOptionsSummary();
			this.renderCommentsSummary();
			this.updateHiddenConfigField();

			console.log(this);
		}

		renderCommentsSummary() {
			if (!this.$commentsSummary.length) return;

			let html = '';
			let hasComments = false;

			// Loop through each step with comments individually (no grouping)
			for (const stepIdx in this.formComments) {
				const commentsData = this.formComments[stepIdx];
				if (Object.keys(commentsData).length === 0) continue;

				// Get step name from our cached step names
				const stepName = this.stepNames[stepIdx] ? this.stepNames[stepIdx].name : `Step ${stepIdx}`;

				// Add each comment
				for (const fieldName in commentsData) {
					const comment = commentsData[fieldName];
					html += `<p><strong>${stepName}:</strong> ${comment}</p>`;
					hasComments = true;
				}
			}

			// Find the comments wrap container
			const $commentsWrap = $('[data-configurator-comments-wrap]', this.$wrap);

			if (hasComments) {
				this.$commentsSummary.html(html);
				$commentsWrap.show();
			} else {
				this.$commentsSummary.empty();
				$commentsWrap.hide();
			}
		}

		updateHiddenConfigField() {
			// Find the hidden config fields inside the summary contact section
			const $topConfigField = $('[data-summary-contact] input[name="extra_info_top"]', this.$wrap);
			const $configField = $('[data-summary-contact] input[name="extra_info"]', this.$wrap);
			const title = $('[data-configurator-title]').text();

			if (!$configField.length) return;

			// Update top field with styled header and image
			if ($topConfigField.length) {
				let topHtml = '';

				// Add styled title header
				topHtml += '<div class="x_2141359883title" style="min-height: 41px; width: 700px; background-color: rgb(113, 184, 255); color: white; display: table; text-align: center"><span style="display: table-cell; vertical-align: middle">' + title.toUpperCase() + '</span></div>';

				// Add image section
				const $baseImage = $('.c-configurator__summary-base-image img', this.$wrap);
				if ($baseImage.length) {
					const imgSrc = $baseImage.attr('src');
					if (imgSrc) {
						topHtml += '<div class="x_2141359883image" style="text-align: center; padding: 10px">';
						topHtml += `<img src="${imgSrc}" alt="Product image" width="450" title="Product image" style="width: 450px">`;
						topHtml += '</div>';
					}
				}

				$topConfigField.val(topHtml);
			}

			// Update bottom field with styled specification
			let bottomHtml = '';

			// Check if we have any form values to display
			let hasOptions = false;
			for (const stepIdx in this.formValues) {
				const stepData = this.formValues[stepIdx];
				if (stepData && Object.keys(stepData).length > 0) {
					hasOptions = true;
					break;
				}
			}

			if (hasOptions) {
				// Add specification header
				bottomHtml += '<div class="x_2141359883specification" style="min-height: 41px; width: 700px; background-color: rgb(113, 184, 255); color: white; text-align: left; padding-left: 20px; display: table"><span style="display: table-cell; vertical-align: middle">SPECIFICATION</span></div>';
				bottomHtml += '<div class="x_2141359883specification_value" style="padding: 25px; line-height: 1.5em; font-size: 10pt">';
				bottomHtml += '<p class="x_2141359883conf_summary_list" id="x_2141359883conf_summary_list"></p>';

				// Add specification items for each selected option
				for (const group of this.stepGroups) {
					// Skip empty groups
					if (!this.groupHasValues(group.steps)) continue;

					// Add items from all steps in this group
					for (const stepIdx of group.steps) {
						const stepData = this.formValues[stepIdx] || {};

						// Add each option as a specification item
						for (const fieldName in stepData) {
							const fieldData = stepData[fieldName];
							let optionName = '';
							let optionValue = '';

							if (fieldData.type === 'checkbox' && fieldData.value === true) {
								// Checkbox format - check if it has a selected option (for multi-choice fields)
								if (fieldData.data && fieldData.data.selectedOption) {
									optionName = fieldData.label.toUpperCase();
									optionValue = fieldData.data.selectedOption;
								} else {
									optionName = fieldData.label.toUpperCase();
									optionValue = 'YES';
								}
							} else if (fieldData.type === 'range') {
								// Range format
								const suffix = fieldData.data && fieldData.data.suffix ? fieldData.data.suffix : '';
								optionName = fieldData.label.toUpperCase();
								optionValue = `${fieldData.value} ${suffix}`.trim();
							} else {
								// Generic format for other field types
								optionName = fieldData.label.toUpperCase();
								optionValue = fieldData.value;
							}

							if (optionName && optionValue) {
								bottomHtml += '<div class="x_2141359883conf_summary_item" style="width: 100%; margin-bottom: 1em">';
								bottomHtml += `<div class="x_2141359883conf_summary_name">${optionName}</div>`;
								bottomHtml += `<div class="x_2141359883conf_summary_price" style="color: rgb(113, 184, 255)">${optionValue}</div>`;
								bottomHtml += '</div>';
							}
						}
					}
				}

				// Add comments if they exist
				const $commentsWrap = $('[data-configurator-comments-wrap]', this.$wrap);
				if (this.$commentsSummary.html()) {
					for (const stepIdx in this.formComments) {
						const commentsData = this.formComments[stepIdx];
						if (Object.keys(commentsData).length === 0) continue;

						// Get step name from our cached step names
						const stepName = this.stepNames[stepIdx] ? this.stepNames[stepIdx].name : `Step ${stepIdx}`;

						// Add each comment
						for (const fieldName in commentsData) {
							const comment = commentsData[fieldName];
							bottomHtml += '<div class="x_2141359883conf_summary_item" style="width: 100%; margin-bottom: 1em">';
							bottomHtml += `<div class="x_2141359883conf_summary_name">${stepName.toUpperCase()} COMMENT</div>`;
							bottomHtml += `<div class="x_2141359883conf_summary_price" style="color: rgb(113, 184, 255)">${comment}</div>`;
							bottomHtml += '</div>';
						}
					}
				}

				bottomHtml += '</div>';
			}

			// Update the bottom hidden field value
			$configField.val(bottomHtml);
		}

		initStepGroups() {
			// Create an array of objects with step groups and their titles
			this.stepGroups = [];
			let currentGroup = [];

			// Get all step indices from stepNames
			const stepIndices = Object.keys(this.stepNames).map(Number).sort((a, b) => a - b);

			for (const stepIdx of stepIndices) {
				// If this step should be grouped with previous and we have a current group
				if (this.stepNames[stepIdx] && this.stepNames[stepIdx].groupWithPrev && currentGroup.length > 0) {
					// Add to the current group
					currentGroup.push(stepIdx);
				} else {
					// Start a new group if the current one is not empty
					if (currentGroup.length > 0) {
						// Add the group with its pre-generated title
						this.stepGroups.push({
							steps: currentGroup,
							title: this.generateGroupTitle(currentGroup)
						});
					}
					currentGroup = [stepIdx];
				}
			}

			// Add the last group if not empty
			if (currentGroup.length > 0) {
				this.stepGroups.push({
					steps: currentGroup,
					title: this.generateGroupTitle(currentGroup)
				});
			}
		}


		// Helper method to check if any step in the group has values
		groupHasValues(groupSteps) {
			for (const stepIdx of groupSteps) {
				const stepData = this.formValues[stepIdx];
				if (stepData && Object.keys(stepData).length > 0) {
					return true;
				}
			}
			return false;
		}



		// Helper method to generate a title for a group of steps
		generateGroupTitle(group) {
			// Get names of steps in this group
			const stepNames = group.map(stepIdx => {
				return this.stepNames[stepIdx] ? this.stepNames[stepIdx].name : `Step ${stepIdx}`;
			});

			if (stepNames.length === 1) {
				// Single step
				return stepNames[0];
			} else if (stepNames.length === 2) {
				// Two steps - format as "Step 1 & Step 2"
				return `${stepNames[0]} & ${stepNames[1]}`;
			} else {
				// More than two steps - format as "Step 1, Step 2, ... & Last Step"
				const lastStep = stepNames.pop();
				return `${stepNames.join(', ')} & ${lastStep}`;
			}
		}

		// Add a new method to set up multi-choice tracking
		setupMultiChoiceTracking() {
			// Find all multi-choice option containers
			const $multiChoiceWrap = $('.c-configurator__multi-choice-wrap', this.$wrap);

			$multiChoiceWrap.each((i, wrap) => {
				const $wrap = $(wrap);
				const $photoContainer = $('[data-multi-choice-photo]', $wrap);
				const $options = $('[data-multi-choice-option]', $wrap);
				const $checkbox = $('input[type="checkbox"]', $wrap);
				const $radioButtons = $options.find('input[type="radio"]');
				const fieldName = $checkbox.attr('name');
				const fieldLabel = $checkbox.data('field-label') || '';
				const isColorQuestion = $wrap.find('.c-configurator__multi-choice').data('is-color-question') === 1;

				// Set initial photo (first option's photo) even when no radio is selected
				this.updateMultiChoicePhotoForFirst($wrap);

				// Handle radio button changes
				$radioButtons.on('change', () => {
					// Update the photo
					this.updateMultiChoicePhoto($wrap);

					// Auto-check the checkbox when a radio option is selected
					if (!$checkbox.prop('checked')) {
						$checkbox.prop('checked', true);

						// Update the summary
						const selectedValue = $('input[type="radio"]:checked', $wrap).val() || '';
						this.updateFormValue(fieldName, true, fieldLabel, 'checkbox', {
							selectedOption: selectedValue
						});
					} else {
						// Update existing summary with new selected option
						const selectedValue = $('input[type="radio"]:checked', $wrap).val() || '';
						this.updateFormValue(fieldName, true, fieldLabel, 'checkbox', {
							selectedOption: selectedValue
						});
					}

					// If this is a color question, update the selected color and refresh all layers
					if (isColorQuestion) {
						this.updateSelectedColor();
						this.updateSummaryLayers();
					}
				});

				// Handle checkbox changes
				$checkbox.on('change', () => {
					const isChecked = $checkbox.prop('checked');

					if (isChecked) {
						// If no radio button is selected, select the first one
						const $checkedRadio = $radioButtons.filter(':checked');
						if ($checkedRadio.length === 0) {
							$radioButtons.first().prop('checked', true);
							this.updateMultiChoicePhoto($wrap);
						}

						const selectedValue = $('input[type="radio"]:checked', $wrap).val() || '';
						this.updateFormValue(fieldName, true, fieldLabel, 'checkbox', {
							selectedOption: selectedValue
						});

						// If this is a color question, update the selected color
						if (isColorQuestion) {
							this.updateSelectedColor();
							this.updateSummaryLayers();
						}
					} else {
						// If checkbox is unchecked, clear the radio selection
						$radioButtons.prop('checked', false);
						this.updateMultiChoicePhotoForFirst($wrap);
						this.removeFormValue(fieldName);

						// If this is a color question, update the selected color
						if (isColorQuestion) {
							this.updateSelectedColor();
							this.updateSummaryLayers();
						}
					}
				});
			});
		}

		// Method to update the photo in a multi-choice field
		updateMultiChoicePhoto($wrap) {
			const $photoContainer = $('[data-multi-choice-photo]', $wrap);
			const $selectedOption = $('input[type="radio"]:checked', $wrap).closest('[data-multi-choice-option]');

			if ($photoContainer.length && $selectedOption.length) {
				// Clone the image from the option and put it in the photo container
				const $optionPhoto = $('[data-multi-choice-option-photo]', $selectedOption);
				const $photoClone = $optionPhoto.children().clone();
				$photoContainer.empty().append($photoClone);
			} else {
				// If no option selected, show the first option's photo
				this.updateMultiChoicePhotoForFirst($wrap);
			}
		}

		// New method to set the photo to the first option when none is selected
		updateMultiChoicePhotoForFirst($wrap) {
			const $photoContainer = $('[data-multi-choice-photo]', $wrap);
			const $firstOption = $('[data-multi-choice-option]', $wrap).first();

			if ($photoContainer.length && $firstOption.length) {
				const $optionPhoto = $('[data-multi-choice-option-photo]', $firstOption);
				const $photoClone = $optionPhoto.children().clone();
				$photoContainer.empty().append($photoClone);
			}
		}

		renderOptionsSummary() {
			if (!this.$optionsSummary.length) return;

			let html = '';

			// Use the pre-calculated step groups
			for (const group of this.stepGroups) {
				// Skip empty groups
				if (!this.groupHasValues(group.steps)) continue;

				// Use the pre-generated title
				html += `<h4>${group.title}</h4><ul>`;

				// Add items from all steps in this group
				for (const stepIdx of group.steps) {
					const stepData = this.formValues[stepIdx] || {};

					// Add each option
					for (const fieldName in stepData) {
						const fieldData = stepData[fieldName];

						if (fieldData.type === 'checkbox' && fieldData.value === true) {
							// Checkbox format - check if it has a selected option (for multi-choice fields)
							if (fieldData.data && fieldData.data.selectedOption) {
								html += `<li>${fieldData.label} - ${fieldData.data.selectedOption}</li>`;
							} else {
								html += `<li>${fieldData.label}</li>`;
							}
						} else if (fieldData.type === 'range') {
							// Range format
							const suffix = fieldData.data && fieldData.data.suffix ? fieldData.data.suffix : '';
							html += `<li>${fieldData.label} - ${fieldData.value} ${suffix}</li>`;
						} else {
							// Generic format for other field types
							html += `<li>${fieldData.label}: ${fieldData.value}</li>`;
						}
					}
				}

				html += `</ul>`;
			}

			this.$optionsSummary.html(html || '<p>No options selected</p>');
		}


		initNoUiSlider() {

			if (!this.$sliders.length) return;

			this.$sliders.each((i, slider) => {
				const $slider = $(slider);
				const min = parseFloat($slider.data('min'));
				const max = parseFloat($slider.data('max'));
				const sliderId = $slider.attr('id');
				const inputField = document.getElementById(`${sliderId}-input`);

				// Check for intermediate values
				let intermediateValues = $slider.data('intermediate');
				let sliderConfig = {};

				if (intermediateValues) {
					// Parse comma-separated values into an array
					const valuesArray = intermediateValues.split(',').map(val => parseFloat(val.trim()));

					// Create full range array including min and max
					const rangeValues = [min, ...valuesArray, max];

					// Create a format object to map index positions to actual values
					const format = {
						to: function (value) {
							// Convert the slider index to the actual numeric value
							return rangeValues[Math.round(value)];
						},
						from: function (value) {
							// Find the index of the value in our array
							return rangeValues.indexOf(parseFloat(value));
						}
					};

					sliderConfig = {
						range: {
							'min': 0,
							'max': rangeValues.length - 1
						},
						step: 1,  // Step by index (1 unit at a time)
						// snap: true,
						connect: 'lower',
						format: format,
						pips: {
							mode: 'steps',
							format: format,
							density: 50,
							// stepped: true
						},
						start: [0]  // Start at the first index
					};
				} else {
					// Simple range slider with min and max
					sliderConfig = {
						range: {
							'min': min,
							'max': max
						},
						start: [min],
						step: (max - min) / 100, // Default step
						pips: {
							mode: 'positions',
							values: [0, 100], // Only show min and max
							density: 0
						}
					};
				}

				// Initialize noUiSlider
				const sliderInstance = noUiSlider.create(slider, sliderConfig);

				// Update value display and hidden input
				sliderInstance.on('update', function (values, handle) {
					let value;

					if (intermediateValues) {
						// For range sliders with intermediate values, the value is already formatted
						value = values[handle];
					} else {
						// For simple sliders, parse the value
						value = parseFloat(values[handle]);
					}

					inputField.value = value;

					// Trigger change event for form validation/submission
					$(inputField).trigger('change');
				});

				// Add click behavior to pips
				this.enablePipClicks(slider);
			});
		}

		// New method to enable pip clicks
		enablePipClicks(slider) {

			const pips = slider.querySelectorAll('.noUi-value');
			const hasFormat = slider.noUiSlider.options.format !== undefined;


			function clickOnPip() {
				let value = this.getAttribute('data-value');
				if (hasFormat) {
					const format = slider.noUiSlider.options.format;
					if (format && format.to) {
						value = format.to(value);
					}
				}
				slider.noUiSlider.set(value);
			}

			for (let i = 0; i < pips.length; i++) {
				pips[i].style.cursor = 'pointer';
				pips[i].addEventListener('click', clickOnPip);
			}

			// Get all markers (the small lines/dots)
			const markers = slider.querySelectorAll('.noUi-marker');

			function clickOnMarker() {
				// Find the closest value pip to this marker
				const closestPip = this.closest('.noUi-marker').nextElementSibling;
				if (closestPip && closestPip.classList.contains('noUi-value')) {
					let value = closestPip.getAttribute('data-value');
					if (hasFormat) {
						const format = slider.noUiSlider.options.format;
						if (format && format.to) {
							value = format.to(value);
						}
					}
					slider.noUiSlider.set(value);
				} else {
					// If no pip found, try to estimate position
					const markerStyle = window.getComputedStyle(this);
					const leftPos = parseFloat(markerStyle.left) / 100;
					const min = slider.noUiSlider.options.range.min;
					const max = slider.noUiSlider.options.range.max;
					const value = min + leftPos * (max - min);
					slider.noUiSlider.set(value);
				}
			}

			// Add click events to markers
			for (let i = 0; i < markers.length; i++) {
				markers[i].style.cursor = 'pointer';
				markers[i].addEventListener('click', clickOnMarker);
			}

		}


		initImageLayers() {
			// Find the color question (if any)
			this.findColorQuestion();

			// Find all fields with layers
			this.collectLayerElements();

			// Initialize the layers in the summary
			if (this.$summaryLayersContainer.length > 0) {
				this.updateSummaryLayers();
			}
		}

		// Find the color question in the configurator
		findColorQuestion() {
			const $colorQuestion = $('[data-is-color-question="1"]', this.$wrap);

			if ($colorQuestion.length > 0) {
				// Get the question information
				const $parentField = $colorQuestion.find('input[data-field-type="single-choice"]');
				const fieldName = $parentField.attr('name');

				if (fieldName) {
					const stepMatch = fieldName.match(/step\[(\d+)\]\[(\d+)\]/);
					if (stepMatch) {
						this.colorQuestion = {
							stepIdx: stepMatch[1],
							fieldIdx: stepMatch[2],
							element: $colorQuestion[0],
							options: []
						};

						// Get all color options
						$colorQuestion.find('[data-is-color-option="1"]').each((i, option) => {
							const $option = $(option);
							this.colorQuestion.options.push({
								value: $option.val(),
								index: $option.data('option-index')
							});
						});
					}
				}
			}
		}

		// Collect all elements with layers
		collectLayerElements() {
			// Look for yes/no questions with layers
			$('input[data-has-layers="1"]', this.$wrap).each((i, input) => {
				const $input = $(input);
				const $parent = $input.closest('.c-configurator__yes-no-wrap');
				const $layersContainer = $('[data-summary-layers]', $parent);

				if ($layersContainer.length > 0) {
					const stepIdx = $layersContainer.data('step-idx');
					const fieldIdx = $layersContainer.data('field-idx');
					const key = `${stepIdx}_${fieldIdx}`;

					this.layerElements[key] = {
						type: 'yes_no',
						element: $layersContainer[0],
						stepIdx: stepIdx,
						fieldIdx: fieldIdx,
						layers: []
					};

					// Collect all layers
					$('[data-layer-index]', $layersContainer).each((j, layer) => {
						const $layer = $(layer);
						const layerIdx = $layer.data('layer-index');
						const manualZIndex = $layer.data('z-index');

						let zIndex;
						if (manualZIndex !== undefined && manualZIndex !== '') {
							zIndex = parseInt(manualZIndex) + parseInt(layerIdx);
						} else {
							zIndex = 100 * parseInt(stepIdx) + 10 * parseInt(fieldIdx) + parseInt(layerIdx);
						}

						this.layerElements[key].layers.push({
							index: layerIdx,
							element: layer,
							zIndex: zIndex
						});
					});
				}
			});

			// Look for single choice questions with layers
			$('[data-summary-option-layers]', this.$wrap).each((i, container) => {
				const $container = $(container);
				const stepIdx = $container.data('step-idx');
				const fieldIdx = $container.data('field-idx');
				const optionIdx = $container.data('option-idx');
				const key = `${stepIdx}_${fieldIdx}_${optionIdx}`;

				this.layerElements[key] = {
					type: 'single_choice',
					element: container,
					stepIdx: stepIdx,
					fieldIdx: fieldIdx,
					optionIdx: optionIdx,
					layers: []
				};

				// Collect all layers
				$('[data-layer-index]', $container).each((j, layer) => {
					const $layer = $(layer);
					const layerIdx = $layer.data('layer-index');
					const manualZIndex = $layer.data('z-index');

					let zIndex;

					if (manualZIndex !== undefined && manualZIndex !== '') {
						// Use manual z-index if set
						zIndex = parseInt(manualZIndex) + parseInt(layerIdx) + parseInt(optionIdx);
					} else {
						// Calculate structured z-index as fallback: 100*stepIdx + 10*fieldIdx + layerIdx
						// For single choice options, we'll add the optionIdx in the ones place
						zIndex = 100 * parseInt(stepIdx) + 10 * parseInt(fieldIdx) + parseInt(layerIdx) + parseInt(optionIdx);
					}
					this.layerElements[key].layers.push({
						index: layerIdx,
						element: layer,
						zIndex: zIndex
					});
				});
			});
		}

		// Update the summary layers based on form selections
		updateSummaryLayers() {
			// Clear existing layers
			this.$summaryLayersContainer.empty();

			// Get the currently selected color (if any)
			this.updateSelectedColor();

			// Add layers for selected options
			for (const key in this.formValues) {
				const stepData = this.formValues[key];

				for (const fieldName in stepData) {
					const fieldData = stepData[fieldName];

					// Extract step and field index
					const stepMatch = fieldName.match(/step\[(\d+)\]\[(\d+)\]/);
					if (!stepMatch) continue;

					const stepIdx = stepMatch[1];
					const fieldIdx = stepMatch[2];
					const lookupKey = `${stepIdx}_${fieldIdx}`;

					// Handle yes/no questions
					if (fieldData.type === 'checkbox' && fieldData.value === true) {
						if (this.layerElements[lookupKey] && this.layerElements[lookupKey].type === 'yes_no') {
							this.addLayersToSummary(this.layerElements[lookupKey], fieldData);
						}
					}

					// Handle single choice questions
					if (fieldData.type === 'checkbox' && fieldData.data && fieldData.data.selectedOption) {
						const optionMatch = fieldName.match(/step\[(\d+)\]\[(\d+)\]/);
						if (!optionMatch) continue;

						// Find the selected option index
						const $parent = $(`input[name="${fieldName}"]`).closest('.c-configurator__multi-choice-wrap');
						const $selectedOption = $(`input[name="${fieldName}[option]"][value="${fieldData.data.selectedOption}"]`, $parent);

						if ($selectedOption.length > 0) {
							const optionIdx = $selectedOption.data('option-index');
							const optionKey = `${stepIdx}_${fieldIdx}_${optionIdx}`;

							if (this.layerElements[optionKey]) {
								this.addLayersToSummary(this.layerElements[optionKey], fieldData);
							}
						}
					}
				}
			}
		}

		// Add layers from an element to the summary
		addLayersToSummary(layerElement, fieldData) {
			let layerFound = false;

			// First try to match the layer index with the selected color index (if a color is selected)
			if (this.selectedColor !== null) {
				const colorIndex = this.selectedColor.index;

				// Try to find a layer with matching color index
				for (const layer of layerElement.layers) {
					if (layer.index == colorIndex) {
						// Clone the layer and add it to the summary
						const $clone = $(layer.element).clone();
						$clone.css({
							'position': 'absolute',
							'top': 0,
							'left': 0,
							'width': '100%',
							'height': '100%',
							'z-index': layer.zIndex
						});
						this.$summaryLayersContainer.append($clone);
						layerFound = true;
						break;
					}
				}
			}

			// If no matching layer found (or no color selected), use the first layer (index 0)
			if (!layerFound) {
				// Find the first layer (index 0)
				const firstLayer = layerElement.layers.find(layer => layer.index == 0);

				if (firstLayer) {
					// Clone the layer and add it to the summary
					const $clone = $(firstLayer.element).clone();
					$clone.css({
						'position': 'absolute',
						'top': 0,
						'left': 0,
						'width': '100%',
						'height': '100%',
						'z-index': firstLayer.zIndex
					});
					this.$summaryLayersContainer.append($clone);
				}
			}
		}

		// Update the selected color information
		updateSelectedColor() {
			this.selectedColor = null;

			if (!this.colorQuestion) return;

			// Build the field name from the color question data
			const fieldName = `step[${this.colorQuestion.stepIdx}][${this.colorQuestion.fieldIdx}]`;

			// Check if this field is in the form values and is checked
			if (this.formValues[this.colorQuestion.stepIdx] &&
				this.formValues[this.colorQuestion.stepIdx][fieldName] &&
				this.formValues[this.colorQuestion.stepIdx][fieldName].value === true) {

				const fieldData = this.formValues[this.colorQuestion.stepIdx][fieldName];

				// If it has a selected option
				if (fieldData.data && fieldData.data.selectedOption) {
					// Find the corresponding option in our color question
					const optionValue = fieldData.data.selectedOption;

					// Find the option index
					const $option = $(`input[name="${fieldName}[option]"][value="${optionValue}"]`, this.$wrap);
					if ($option.length > 0) {
						const optionIndex = $option.data('option-index');

						this.selectedColor = {
							value: optionValue,
							index: parseInt(optionIndex)
						};
					}
				}
			}
		}

	}

})(jQuery);

var configuratorInit$1 = configuratorInit;

var advisorInit;

(function ($) {
	const selectors = {
		wrap: '[data-advisor]',
		intro: '[data-advisor-intro]',
		startBtn: '[data-advisor-start]',
		content: '[data-advisor-content]',
		question: '[data-advisor-question]',
		firstQuestion: '.c-advisor__question.is-first',
		answerBtn: '[data-advisor-answer]',
		selectedAnswer: '.is-selected',
		products: '[data-advisor-products]',
		contactForm: '[data-advisor-contact-form]',
		hiddenField: 'input[name="extra_info"]' // Selector for the hidden field
	};

	advisorInit = function () {
		$(selectors.wrap).each((i, el) => {
			new Advisor(el);
		});
	};

	class Advisor {
		constructor(element) {
			this.$wrap = $(element);

			// Path tracking for form submission
			this.pathData = {
				questions: [],
				answers: []
			};

			this.init();
			this.bind();
		}

		init() {
			this.$intro = this.$wrap.find(selectors.intro);
			this.$startBtn = $(selectors.startBtn);
			this.$content = this.$wrap.find(selectors.content);
			this.$contactForm = this.$wrap.find(selectors.contactForm);
			this.$hiddenField = this.$wrap.find(selectors.hiddenField);

			// Track the path of active questions
			this.activePath = [];

			// Animation duration
			this.animDuration = 400;
		}

		bind() {
			const self = this;

			// Start button click
			this.$startBtn.on('click', function () {
				self.startAdvisor();
			});

			// Answer button clicks
			this.$wrap.on('click', selectors.answerBtn, function () {
				const $btn = $(this);
				const questionId = $btn.data('question-id');
				const answerIndex = $btn.data('advisor-answer');
				const answerType = $btn.data('answer-type');
				const nextQuestionId = $btn.data('next-question');

				self.handleAnswer($btn, questionId, answerIndex, answerType, nextQuestionId);
			});
		}

		startAdvisor() {
			// Hide intro section
			this.$intro.slideUp(this.animDuration);

			// Show content container
			this.$content.slideDown(this.animDuration);

			// Add first question to active path
			const $firstQuestion = this.$wrap.find(selectors.firstQuestion);
			const questionId = $firstQuestion.data('advisor-question');
			const questionText = $firstQuestion.find('.c-advisor__question-title').text().trim();

			this.activePath.push({
				questionId: questionId,
				$element: $firstQuestion
			});

			// Add to path data
			this.addToPathData(questionId, questionText);
		}

		handleAnswer($btn, questionId, answerIndex, answerType, nextQuestionId) {
			const self = this;
			const $question = $btn.closest(selectors.question);

			// Get answer text
			const answerText = $btn.text().trim();

			// Mark this answer as selected
			$question.find(selectors.answerBtn).removeClass('is-selected');
			$btn.addClass('is-selected');

			// Store information about what was visible before making changes
			const visibleProductsBefore = this.$wrap.find(`${selectors.products}:visible`).length > 0;

			// Find the index of this question in the active path
			const pathIndex = this.findPathIndex(questionId);

			// If we found it, remove everything after it from path data and DOM
			if (pathIndex !== -1) {
				// Remove items after this one from the path
				const removedItems = this.activePath.splice(pathIndex + 1);

				// Hide all content that's no longer in our path
				this.hideRemovedContent(questionId, answerIndex);

				// Trim the path data to match the UI state
				this.trimPathData(pathIndex);
			}

			// Add the answer to path data
			this.addAnswerToPathData(questionId, answerText);

			// Check if this is the last visible question (to determine if we should scroll)
			const isLastQuestion = this.isLastVisibleQuestion($question);

			// Show next content based on answer type
			if (answerType === 'question' && nextQuestionId) {
				// Find the next question
				const $nextQuestion = this.$wrap.find(`${selectors.question}[data-advisor-question="${nextQuestionId}"]`);
				const nextQuestionText = $nextQuestion.find('.c-advisor__question-title').text().trim();

				// Check if it's already visible (changing an answer vs. revealing new content)
				const revealingNewQuestion = !$nextQuestion.is(':visible');

				// Get the current question's height for scrolling calculation
				const questionHeight = $question.outerHeight();

				// Show the question
				$nextQuestion.slideDown(this.animDuration, function () {
					// Only scroll if this was the last question AND we're revealing a new question
					if (isLastQuestion && revealingNewQuestion) {
						self.scrollByHeight(questionHeight);
					}
				});

				// Add to active path
				this.activePath.push({
					questionId: nextQuestionId,
					$element: $nextQuestion
				});

				// Add to path data
				this.addToPathData(nextQuestionId, nextQuestionText);

				// Hide contact form when showing a question
				this.$contactForm.slideUp(this.animDuration);
			}
			else if (answerType === 'products') {
				// Find product recommendations
				const $products = this.$wrap.find(`${selectors.products}[data-advisor-products="${questionId}-${answerIndex}"]`);

				// Get product titles for path data
				const productTitles = [];
				$products.find('.c-advisor__product-title').each(function () {
					productTitles.push($(this).text().trim());
				});

				// Add products to path data
				this.addProductsToPathData(productTitles);

				// We should only scroll if:
				// 1. This is the last question
				// 2. There were no products visible before OR we're showing completely new products
				// (not just changing from one product set to another)
				const shouldScroll = isLastQuestion && !visibleProductsBefore;

				// Get the current question's height for scrolling calculation
				const questionHeight = $question.outerHeight();

				// Show the products
				$products.slideDown(this.animDuration, function () {
					// Only scroll when appropriate
					if (shouldScroll) {
						self.scrollByHeight(questionHeight);
					}
				});

				// Show contact form if it's not visible
				if (!this.$contactForm.is(':visible')) {
					this.$contactForm.slideDown(this.animDuration);
				}
			}

			// Update the hidden field
			this.updateHiddenField();
		}

		// Add a question to the path data
		addToPathData(questionId, questionText) {
			this.pathData.questions.push({
				id: questionId,
				text: questionText
			});
		}

		// Add an answer to the path data
		addAnswerToPathData(questionId, answerText) {
			// Find the index of the question in the path data
			const questionIndex = this.pathData.questions.findIndex(q => q.id == questionId);

			// If found, add/update the answer
			if (questionIndex !== -1) {
				// Make sure answers array is at least as long as questions array
				while (this.pathData.answers.length < questionIndex) {
					this.pathData.answers.push('');
				}

				// Set the answer at the matching index
				this.pathData.answers[questionIndex] = answerText;
			}
		}

		// Add products to path data
		addProductsToPathData(productTitles) {
			this.pathData.products = productTitles;
		}

		// Trim path data to match the UI state
		trimPathData(questionIndex) {
			// Keep only up to the specified question index
			this.pathData.questions = this.pathData.questions.slice(0, questionIndex + 1);
			this.pathData.answers = this.pathData.answers.slice(0, questionIndex + 1);

			// Remove products data if we're changing a question
			delete this.pathData.products;
		}

		// Update the hidden field with the current path data
		updateHiddenField() {
			if (!this.$hiddenField.length) return;

			let html = '';

			// Customer Choices Section
			if (this.pathData.questions.length > 0) {
				html += '<div class="x_2141359883specification" style="min-height: 41px; width: 700px; background-color: rgb(113, 184, 255); color: white; text-align: left; padding-left: 20px; display: table"><span style="display: table-cell; vertical-align: middle">CUSTOMER CHOICES</span></div>';
				html += '<div class="x_2141359883specification_value" style="padding: 25px; line-height: 1.5em; font-size: 10pt">';
				html += '<p class="x_2141359883conf_summary_list" id="x_2141359883conf_summary_list"></p>';

				// Add questions and answers
				for (let i = 0; i < this.pathData.questions.length; i++) {
					const question = this.pathData.questions[i];
					const answer = this.pathData.answers[i] || '';

					if (answer) {
						html += '<div class="x_2141359883conf_summary_item" style="width: 100%; margin-bottom: 1em">';
						html += `<div class="x_2141359883conf_summary_name">${question.text.toUpperCase()}</div>`;
						html += `<div class="x_2141359883conf_summary_price" style="color: rgb(113, 184, 255)">${answer}</div>`;
						html += '</div>';
					}
				}

				html += '</div>';
			}

			// Recommended Products Section
			if (this.pathData.products && this.pathData.products.length > 0) {
				html += '<div class="x_2141359883specification" style="min-height: 41px; width: 700px; background-color: rgb(113, 184, 255); color: white; text-align: left; padding-left: 20px; display: table; margin-top: 20px"><span style="display: table-cell; vertical-align: middle">RECOMMENDED PRODUCTS</span></div>';
				html += '<div class="x_2141359883specification_value" style="padding: 25px; line-height: 1.5em; font-size: 10pt">';
				html += '<p class="x_2141359883conf_summary_list" id="x_2141359883conf_summary_list"></p>';

				this.pathData.products.forEach(product => {
					html += '<div class="x_2141359883conf_summary_item" style="width: 100%; margin-bottom: 1em">';
					html += `<div class="x_2141359883conf_summary_name">${product.toUpperCase()}</div>`;
					html += '</div>';
				});

				html += '</div>';
			}

			// Update the hidden field
			this.$hiddenField.val(html);
		}

		// Check if a question is the last visible question
		isLastVisibleQuestion($question) {
			// Get all visible questions
			const $visibleQuestions = this.$wrap.find(`${selectors.question}:visible`);

			// Check if this is the last one
			return $visibleQuestions.last().is($question);
		}

		// Scroll by a specific height
		scrollByHeight(height) {
			const currentScroll = $(window).scrollTop();

			$('html, body').animate({
				scrollTop: currentScroll + height
			}, 500, 'swing');
		}

		findPathIndex(questionId) {
			for (let i = 0; i < this.activePath.length; i++) {
				if (this.activePath[i].questionId == questionId) {
					return i;
				}
			}
			return -1;
		}

		hideRemovedContent(currentQuestionId, selectedAnswerIndex) {
			const self = this;

			// Hide all questions that depend on this one but with different answers
			this.$wrap.find(selectors.question).each(function () {
				const $question = $(this);
				const parentId = $question.data('parent-question');
				const parentAnswer = $question.data('parent-answer');

				// If this question depends on the current question but through a different answer
				if (parentId == currentQuestionId && parentAnswer != selectedAnswerIndex) {
					$question.slideUp(self.animDuration);

					// Also hide any content that depends on this question
					self.hideChildContent($question.data('advisor-question'));
				}
			});

			// Hide all products that depend on this question but with different answers
			this.$wrap.find(selectors.products).each(function () {
				const $products = $(this);
				const parentId = $products.data('parent-question');
				const parentAnswer = $products.data('parent-answer');

				// If these products depend on the current question but through a different answer
				if (parentId == currentQuestionId && parentAnswer != selectedAnswerIndex) {
					$products.slideUp(self.animDuration);
				}
			});
		}

		hideChildContent(questionId) {
			const self = this;

			// Hide all questions that depend on this one
			this.$wrap.find(selectors.question).each(function () {
				const $question = $(this);
				const parentId = $question.data('parent-question');

				// If this question depends on the specified question
				if (parentId == questionId) {
					$question.slideUp(self.animDuration);

					// Also hide any content that depends on this question
					self.hideChildContent($question.data('advisor-question'));
				}
			});

			// Hide all products that depend on this question
			this.$wrap.find(selectors.products).each(function () {
				const $products = $(this);
				const parentId = $products.data('parent-question');

				// If these products depend on the specified question
				if (parentId == questionId) {
					$products.slideUp(self.animDuration);
				}
			});
		}
	}
})(jQuery);

var advisorInit$1 = advisorInit;

var scrollerInit;

(function ($) {

	// Immediately execute this before any other code runs
	const originalHash = window.location.hash;
	if (originalHash) {
		// Remove hash without triggering scroll
		history.replaceState('', document.title, window.location.pathname + window.location.search);
	}

	const selectors = {
		trigger: 'a[href^="#"]:not([href="#"]):not([data-tabs-link]):not([data-fancybox])',
		scrollTop: '[data-scroll-top]'
	};

	const handleHash = (hash) => {
		if (hash && hash.length > 1) {
			const $target = $(hash);
			if ($target.length) {
				const additionalOffset = $target.is('a') ? 0 : -1 * (document.headerHeightScrolled * 1);
				const targetScroll = $target.offset().top + additionalOffset;
				history.replaceState(null, null, hash);

				setTimeout(_ => {
					window.scrollTo(0, targetScroll);

				}, 100);


			}
		}
	};


	scrollerInit = function () {
		// Handle stored hash on page load
		if (originalHash) {
			handleHash(originalHash);
		}

		$(selectors.trigger).each((i, el) => {
			new Scroller(el);
		});
		$(selectors.scrollTop).each((i, el) => {
			new Scroller(el, 0);
		});
	};


	class Scroller {
		constructor(trigger, offset) {
			this.$trigger = $(trigger);
			this.offset = offset;
			this.$target = $(this.$trigger.attr('href'));

			if (this.$target.length || this.offset !== undefined) {
				this.init();
				this.bind();
			}

		}
		init() {
			this.additionalOffset = this.$target.is('a') ? 0 : -1 * (document.headerHeightScrolled * 1);
		}

		bind() {
			this.$trigger.on('click', this.scroll.bind(this));
		}

		scroll(e) {
			e.preventDefault();
			const $trigger = $(e.delegateTarget);

			if ($trigger.attr('href').length > 1 && $('[data-modal]' + $trigger.attr('href')).length) return;

			const targetScroll = (this.offset === undefined) ? (this.$target.offset().top + this.additionalOffset) : this.offset;

			$('body').addClass('scroller-scrolling');
			$('html, body').animate({
				scrollTop: targetScroll
			}, 700, _ => {
				$('body').removeClass('scroller-scrolling');
			});
		}

	}

})(jQuery);


var scrollerInit$1 = scrollerInit;

var topInfoBarInit;

(function ($) {
	const selectors = {
		wrapper: '[data-top-info-bar]',
		track: '[data-top-info-bar-track]',
		content: '[data-top-info-bar-content]'
	};

	topInfoBarInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new TopInfoBar(el);
		});
	};

	class TopInfoBar {
		constructor(element) {
			this.$wrapper = $(element);
			this.$track = this.$wrapper.find(selectors.track);
			this.$contents = this.$wrapper.find(selectors.content);

			this.init();
			this.bind();
		}

		init() {
			// Initial check
			this.checkWidth();

		}

		bind() {
			// Bind resize event
			$(window).on('resize', this.debounce(this.checkWidth.bind(this), 250));
		}

		checkWidth() {
			const wrapperWidth = this.$wrapper.width() - 16;
			const firstContentWidth = this.$contents.eq(0).outerWidth(true);

			// If first content span is wider than wrapper, enable animation
			if (firstContentWidth > wrapperWidth) {
				this.$track.addClass('is-animating');
			} else {
				this.$track.removeClass('is-animating');
			}
		}

		// Simple debounce function to prevent excessive updates
		debounce(func, wait) {
			let timeout;
			return function () {
				const context = this;
				const args = arguments;
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					func.apply(context, args);
				}, wait);
			};
		}
	}

})(jQuery);

var topInfoBarInit$1 = topInfoBarInit;

var fixtoInit;

(function ($) {

	const selectors = {
		wrapper: '[data-fixto-wrap]',
		box: '[data-fixto]'
	};


	fixtoInit = function () {
		$(selectors.box).each((i, el) => {
			new Fixto(el);
		});
	};


	class Fixto {
		constructor(element) {
			this.box = element;
			this.wrapper = $(this.box).closest(selectors.wrapper).get(0);

			this.onMobile = $(this.box).attr('data-on-mobile') !== undefined;

			if ($(this.wrapper).length) {
				this.init();
				this.bind();
				$(window).trigger('scroll');
				$(window).trigger('resize');
			}

		}
		init() {

			const self = this;

			self.offTop = 0;
			if ($(this.box).attr('data-offset')) this.offTop += parseInt($(this.box).attr('data-offset'));

			this.args = {
				top: self.offTop,
				useNativeSticky: false,
				mind: ''
			};

			if ($(this.box).attr('data-mind')) this.args.mind += ',' + $(this.box).attr('data-mind');

			self.fixto = fixto.fixTo(this.box, this.wrapper, this.args);

		}

		bind() {
			$(window).on('scroll', this.onScroll.bind(this));
			$(window).on('resize', this.onResize.bind(this));
		}

		onResize() {
			if (this.onMobile) return;
			const self = this;
			if ($(window).width() < 600) {
				self.fixto.stop();
			}
			else {
				self.fixto.start();
			}
		}

		onScroll() {

			const self = this;

			const over_banner = !($(window).scrollTop() > $('.o-banner').outerHeight() - self.offTop - window.headerHeight);

			if (over_banner && $(self.box).hasClass('not-on-banner')) {
				$(self.box).removeClass('not-on-banner');
			}
			else if (!over_banner && !$(self.box).hasClass('not-on-banner')) {
				$(self.box).addClass('not-on-banner');

			}

		}

	}

})(jQuery);


var fixtoInit$1 = fixtoInit;

var scrollNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-scroll-nav]',
		fixtoWrapper: '[data-fixto-wrapper]'
	};

	scrollNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new ScrollNav(el);
		});
	};

	class ScrollNav {
		constructor(element) {
			this.nav = element;

			this.init();
			this.resize();
			this.bind();


		}
		init() {

			this.links = $('a[href^="#"]:not([href="#"])', this.nav);

			if ($(this.nav).closest(selectors.fixtoWrapper).length) {
				this.fixto = fixto.fixTo(this.nav, $(this.nav).closest(selectors.fixtoWrapper).get(0), {
					top: window.scrollOffset ? window.scrollOffset : 0,
					useNativeSticky: false
				});
			}

			this.targets = [];
			this.links.each((i, link) => {

				var $target = $($(link).attr('href'));

				if ($target.length) {
					this.targets.push({
						el: $target.get(0),
						link: link,
						offset: $target.offset().top
					});
				}

			});
		}
		resize() {
			$(this.targets).each((i, targetData) => {
				targetData.offset = $(targetData.el).offset().top;
			});

			this.targets.sort((a, b) => (a.offset > b.offset) ? 1 : ((b.offset > a.offset) ? -1 : 0));

		}
		bind() {

			$(document).ready((e) => { this.resize(); });
			$(window).resize((e) => { this.resize(); });

			$(window).scroll((e) => { this.scroll(); });

			$(window).on('smooth-scroll-started', (e) => { this.isScrolling = true; });
			$(window).on('smooth-scroll-ended', (e) => { this.isScrolling = false; });

			$(this.links).click((e) => { this.linkClicked($(e.target).closest('a').get(0)); });
		}

		scroll() {

			if (this.isScrolling) return;

			const winOffset = $(window).width() >= 900 ? 140 : 70;

			var _this = this;

			// console.log("#######");

			$(this.targets).each((i, targetData) => {

				var scrollOff = $(window).scrollTop() + winOffset + 1;

				var is_active = scrollOff >= targetData.offset;

				if (i < _this.targets.length - 1 && scrollOff >= _this.targets[i + 1].offset)
					is_active = false;

				if (is_active) {
					$(targetData.link).addClass('is-active');
				}
				else {
					$(targetData.link).removeClass('is-active');
				}

			});

		}

		linkClicked(link) {
			$(this.links).removeClass('is-active');
			$(link).addClass('is-active');
		}

	}

})(jQuery);


var scrollNavInit$1 = scrollNavInit;

var footerInit;

(function ($) {

	const selectors = {
		container: '.c-footer',
	};

	footerInit = function () {
		$(selectors.container).each((i, el) => {
			new Footer(el);
		});
	};

	class Footer {
		constructor(element) {
			this.$wrap = $(element);

			this.init();

		}
		init() {

			$('.c-footer__nav', this.$wrap).attr('data-accordions', '');
			$('.c-footer__nav > li ', this.$wrap).attr('data-accordion', '');
			$('.c-footer__nav > li > a', this.$wrap).attr('data-accordion-trigger', '');
			$('.c-footer__nav > li > .sub-menu', this.$wrap).attr('data-accordion-content', '');


		}
	}
})(jQuery);


var footerInit$1 = footerInit;

(function ($) {

	$(document).ready(function () {

		documentInit$1();
		navInit$1();
		mobileNavInit$1();
		footerInit$1();
		accordionInit$1();
		tabsInit$1();
		scrollerInit$1();
		scrollNavInit$1();

		fancyboxInit$1();
		slickInit$1();
		fixtoInit$1();

		faqInit$1();
		topInfoBarInit$1();
		contactFormInit$1();
		configuratorInit$1();
		advisorInit$1();

		$(document).trigger('hp-plugins-loaded');

	});

})(jQuery);

}());
